PJQ.app.attachReadyEvent(function () {
	if (PJQ.app.module === PJQ.constants.modules.PROFILE_OLD) {
		PJQ.app.addOldRoutes([
			{
				route: '',
				name: 'default',
				callback: function () {
					if (PJQ.app.session.isLoggedIn()) {
						PJQ.app.router.navigate('profile', {
							trigger: true,
							replace: true
						});
					}
					else {
						if (PJQ.app.module === PJQ.constants.modules.APP) {
							PJQ.app.router.navigate('signin', {
								trigger: true,
								replace: true
							});
						}
						else {
							new PJQ.views.auth.AuthModal({
								contactId: PJQ.app.session.contact.id,
								defaultSignUpUsername: PJQ.app.session.contact.get('email')
							});
						}
					}
				}
			}
		]);
	}
});

PJQ.modules.profile = {
	routes: [
		{
			route: 'profile',
			name: 'myProfile',
			callback: function (key) {
				if (PJQ.app.module === PJQ.constants.modules.APP) {
					PJQ.app.initNavigator({
						activeItem: "profile"
					});
				}
				else {
					PJQ.app.view.renderProfile();
				}
			}
		},
		{
			route: 'profiles/:key',
			name: 'profiles',
			callback: function (key) {
				if (PJQ.app.module === PJQ.constants.modules.APP) {
					PJQ.app.initNavigator({
						activeItem: "profile",
						viewOptions: {
							key: key,
							shouldDoFirstRoute: false
						}
					});
				}
				else {
					PJQ.app.view.renderProfile(key);
				}
			}
		},
		{
			route: 'profiles/:key/:tab',
			name: 'profiles',
			callback: function (key, tab) {
				if (PJQ.app.module === PJQ.constants.modules.APP) {
					PJQ.app.initNavigator({
						activeItem: "profile",
						viewOptions: {
							key: key,
							tab: tab,
							shouldDoFirstRoute: false
						}
					});
				}
				else {
					PJQ.app.view.renderProfile(key, tab);
				}
			}
		},
		{
			route: 'prequal',
			name: 'myPrequal',
			callback: function () {
				if (PJQ.app.session.isLoggedIn()) {
					PJQ.app.initNavigator({
						activeItem: "prequal"
					});
				}
				else{
					new PJQ.views.auth.AuthModal({
						contactId: PJQ.app.session.contact.id,
						defaultSignUpUsername: PJQ.app.session.contact.get('email')
					});
				}
			}
		},
		{
			route: 'prequal/:prequalKey/:rmuid',
			name: 'prequalLink',
			callback: function (prequalKey, masterUserId) {
				PJQ.app.initNavigator({
					activeItem: "prequal",
					viewOptions: {
						prequalKey: prequalKey,
						masterUserId: parseInt(masterUserId),
						noRoute: true
					}
				});
			}
		},
		{
			route: 'screenings/:accessKey',
			name: 'screenings',
			callback: function (accessKey) {
				if (PJQ.app.module === PJQ.constants.modules.APP) {
					PJQ.app.initNavigator({
						activeItem: "screenings",
						viewOptions: {
							key: key,
							tab: tab,
							shouldDoFirstRoute: false
						}
					});
				}
				else {
					PJQ.modules.profile.initScreenings();
				}
			}
		},
		{
			route: 'screenings',
			name: 'screenings',
			callback: function () {
				if (PJQ.app.module === PJQ.constants.modules.APP) {
					PJQ.app.initNavigator({
						activeItem: "screenings",
						viewOptions: {
							shouldDoFirstRoute: false
						}
					});
				}
				else {
					PJQ.modules.profile.initScreenings();
				}
			}
		}
	],
	oldRoutes: [
		{
			route: "?cid",
			callback: function () {
				if (PJQ.app.session.isLoggedIn()) {
					PJQ.app.router.navigate('profile', {
						trigger: true,
						replace: true
					});
				}
				else {
					new PJQ.views.auth.AuthModal({
						contactId: PJQ.app.session.contact.id,
						defaultSignUpUsername: PJQ.app.session.contact.get('email')
					});
				}
			}
		},
		{
			route: "?dir ?pid ?sid",
			callback: function () {
				if (PJQ.app.session.isLoggedIn()) {
					PJQ.app.router.navigate('screenings', {
						trigger: true,
						replace: true
					});
				}
				else {
					new PJQ.views.auth.AuthModal({
						contactId: PJQ.app.session.contact.id,
						defaultSignUpUsername: PJQ.app.session.contact.get('email')
					});
				}
			}
		}
	],
	initScreenings: function () {
		if (PJQ.app.session.isLoggedIn()) {
			let terms = new PJQ.collections.screenings.ScreeningTerms();
			terms.fetch({
				success: function () {
					if (_.find(terms.models, function (term) {
						return term.get('isActive') && !term.get('isAccepted')
					}) != null) {
						new PJQ.views.screenings.ScreeningTermsModal({
							collection: terms,
							onComplete: function () {
								PJQ.modules.profile.renderScreeningDashboard();
							}
						});
					}
					else {
						PJQ.modules.profile.renderScreeningDashboard();
					}
				}
			});
		}
		else {
			//if they dont have a userid > 0, show the login/registration form
			new PJQ.views.auth.AuthModal({
				contactId: PJQ.app.session.contact.id,
				defaultSignUpUsername: PJQ.app.session.contact.get('email')
			});
		}
	},
	renderScreeningDashboard: function () {
		PJQ.app.view.renderScreeningDashboard();
	}
};

PJQ.helpers.prequalHelpers = {
	addAll: function () {
		let result = 0;
		_.each(arguments, function (arg) {
			let flArg = parseFloat(arg);
			result += isNaN(flArg) ? 0 : flArg;
		});
		return result.toString();
	},
	multiplyAll: function () {
		if (_.size(arguments) <= 1) {
			return 0;
		}

		let result = null;
		_.each(arguments, function (arg) {
			let flArg = parseFloat(arg);
			if (isNaN(flArg)) {
				return;
			}
			result = result != null ? (flArg * result) : flArg
		});
		return result.toString();
	}
};

PJQ.app.addRoutes(PJQ.modules.profile.routes);

//We need to support old routes for all the old links floating around
PJQ.app.addOldRoutes(PJQ.modules.profile.oldRoutes);
//Views
PJQ.views.prequal = {};

PJQ.views.prequal.PrequalEditor = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Form-Editor'),
        subTemplates: {
            tab: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Form-Tab'),
            fieldCategory: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Form-Field-Category'),
            field: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Form-Field'),
            fieldInput: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Form-Field-Input'),
            otherOffice: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Form-Other-Office'),
            contact: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Form-Contact'),
            projectReference: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Form-Project-Reference'),
            faq: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-FAQ'),
            nav: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Nav'),
            requestedBy: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'requested-by'),
            comments: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'prequal-comments')
        },
        tokens: {
            currentYear: PJQ.helpers.dateHelpers.getCurrentYear()
        },
        baseFaqItems: [
            {
                q: "Why am I being asked to complete this form?",
                a: "The requesting General Contractor, in an effort to improve their bidding process and ensure data consistency among their subcontractors have asked all subcontractors to keep on file updated company qualification data."
            },
            {
                q: "How often do I need to update this information?",
                a: "You have the ability to update your information at any time.  Only certain performance data will be required to updated annually as a majority of your company information may not change."
            },
            {
                q: "I've worked with the requesting General Contractor many times in the past, why am I being asked to complete this now?",
                a: "The requesting General Contractor is updating their database so that all subcontractors have current and consistent company and performance information on file regardless of previous contract awards."
            },
            {
                q: "What if I don’t know the answers to all the questions being asked?",
                a: "If you do not have the information on hand, you may return to the form once you are ready.  All of your previously entered information will remain intact."
            },
            {
                q: "I've completed every field but the form is not at 100%.",
                a: "Fields that are incomplete will be highlighted in red. Common fields that are overlooked as complete are phone number fields which require all 10 digits to be considered complete.  You can view the left hand menu to determine which section is incomplete."
            },
            {
                q: "One of our divisions/offices already filled in this information and it's all the same. Do I need to do it again?",
                a: "If you have received the request multiple times to your same email address, please contact the General Contractor as this means you have been entered twice in the address book of the General Contractor. If the requests have gone to different contacts within your company and each contact is responsible for submitting bids for their respective office/division, then yes each contact will need to fill out the form."
            }
        ],
        proqualFaqItems: [
            {
                q: "I have never received a bid or job from this GC, why should I complete this form?",
                a: "In an effort to make better subcontracting decisions and provide subcontractors with the right opportunities, the data on this form will help us get you the requests that match your specialties with our upcoming work.  Filling out this form will increase the likelihood that you will be considered for a project in the future."
            },
            {
                q: "I only want to complete this form if I'm awarded a job.",
                a: "The requesting General Contractor is utilizing the this data in addition to information provided with bids. By taking the 15 minutes to complete this now will them know who is serious about bidding."
            }
        ],
        commentsExpanded: false,
        canEdit: true,
        isAdmin: false,
        onContactChange: null,
        onCompanyCustomFieldChange: null,
        onContactCustomFieldChange: null
    },
    events: {
        'keydown .input-zip': 'allowZip',
        'keydown .input-dollars-full,.input-numeric,.input-percent': 'numbersOnly',
        'change .input-percent': 'formatPercent',
        'click .add-other-office': 'addOtherOffice',
        'click .delete-other-office': 'deleteOtherOffice',
        'click .add-owner-contact': 'addOwnerContact',
        'click .delete-owner-contact': 'deleteOwnerContact',
        'click .add-operations-contact': 'addOperationsContact',
        'click .delete-operations-contact': 'deleteOperationsContact',
        'click .add-estimating-contact': 'addEstimatingContact',
        'click .delete-estimating-contact': 'deleteEstimatingContact',
        'click .add-safety-contact': 'addSafetyContact',
        'click .delete-safety-contact': 'deleteSafetyContact',
        'click .add-project-reference': 'addProjectReference',
        'click .delete-project-reference': 'deleteProjectReference',
        'click .network-upgrade': 'networkUpgrade',
        'click .edit-profile': 'editProfile',
        'click .view-prequal-faq': 'viewFaq',
        'shown.bs.tab .prequal-nav-item': 'navClicked',
        'click .download-prequal-field-file': 'downloadFieldFile',
        'click .prequal-tab-next': 'nextTab',
        'click .prequal-tab-previous': 'previousTab',
        //todo: remove this once prequal is moved to dialog on screenings page
        'click .btn-continue': "continue"
    },
    beforeFirstRender: function () {
        if (this.model.contact != null) {
            this.model.contact.attributes.contactCustomFieldValues = null;
            this.model.contact.attributes.companyCustomFieldValues = null;
        }

        this.clients = this.options.clients;

        this.listenTo(this.model, "fetch", this.render);

        let $pru = $('.prequal-request-update');
        $pru.off();
        $pru.on('click', _.bind(this.requestUpdate, this));
    },
    beforeRender: function () {
        this.options.canEdit = this.options.canEdit && (this.options.isAdmin || !this.model.get('isLocked'));
    },
    requestUpdate: function () {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'contacts',
                    value: this.model.contact.id
                },
                {
                    endpoint: 'prequal'
                },
                {
                    endpoint: 'request'
                }
            ])
        }).post().done(_.bind(function (data) {
            if (data && data.success) {
                PJQ.notifications.notify.successNotify({
                    message: 'Prequalification update sent'
                });
                $('.prequal-request-update').html('<i class="fal fa-check mr-1"></i>Update Sent').prop('disabled', true);
                this.model.set({
                    lastRequestedBy: PJQ.app.session.user.toJSON(),
                    lastRequestedOn: new Date()
                }, {silent: true});
                this.renderRequestedBy();
            } else {
                PJQ.notifications.notify.errorNotify({
                    message: 'Qualification update failed, invalid email address on contact'
                });
            }
        }, this)).fail(function (xhr, err, result) {
            new PJQ.logging.Debug(PJQ.logging.LoggingActions.SEND_PREQUAL_UPDATE, {
                error: err,
                result: result
            });
        });
    },
    renderData: function () {
        return {
            model: this.model,
            renderTokens: _.bind(this.renderTokens, this),
            isAdmin: this.options.isAdmin
        };
    },
    afterRender: function () {
        if (this.model.id > 0) {
            this.renderNav(_.bind(function () {
                if (this.model.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PREQUAL_COMMENTS) && PJQ.app.session.hasPermission('prequal.canViewComments')) {
                    this.renderComments();
                }
                this.renderForm();
                this.$nav.animateCSS('slideDown');
                this.$('.prequal-form-container').animateCSS('fadeIn');
            }, this));
        } else {
            new PJQ.Loader(this.$('.prequal-loader'), {
                type: 'block'
            });
        }
    },
    renderComments: function () {
        this.$comments = this.options.navContainer.parent().find('.comments-outer');
        this.$comments.removeClass('hidden');
        if (!PJQ.app.session.hasPermission('prequal.canAddComments')) {
            this.$comments.find('.btn-add-comment').addClass('hidden');
        } else {
            this.$comments.find('.btn-add-comment').off().on('click', _.bind(this.addComment, this));
        }
        this.renderSubTemplate(false, this.options.subTemplates.comments, this.$comments.find('.prequal-comments'), {
            comments: this.model.comments.models,
            expand: this.options.commentsExpanded,
            canDelete: PJQ.app.session.hasPermission('prequal.canDeleteComments')
        }, _.bind(function ($comm) {
            $comm.find('.btn-expand-comments').on('click', _.bind(this.expandComments, this));
            $comm.find('.btn-delete-comment').off().on('click', _.bind(this.deleteComment, this));
        }, this));
    },
    addComment: function () {
        new PJQ.views.comments.CommentsModal({
            onAddComment: _.bind(function (commentText) {
                let newComment = new PJQ.models.prequal.Comment({
                    contactCompanyId: this.model.get('contactCompanyId'),
                    commentText: commentText,
                    masterUserId: this.model.get('masterUserId')
                });
                newComment.save(null, {
                    success: _.bind(function () {
                        this.model.comments.add(newComment);
                        this.renderComments();
                    }, this)
                });
            }, this)
        });
    },
    expandComments: function () {
        this.options.commentsExpanded = true;
        this.$comments.find('.expand-comments-outer').remove();
        this.$comments.find('.comments-extra').animateCSS('slideDown');
    },
    deleteComment: function(e) {
        let target = $(e.currentTarget),
            $comment = target.closest('.card'),
            cid = $comment.data().cid,
            comment = this.model.comments.get(cid);

        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this comment?",
            onDelete: _.bind(function () {
                this.model.comments.remove(comment);
                comment.destroy();
                this.renderComments();
            }, this)
        });
    },
    renderNav: function (callback) {
        if (this.$nav != null) {
            this.$nav.remove();
            this.$nav = null;
        }

        this.$nav = $('<div>', {
            class: 'prequal-nav-container hidden'
        });
        this.addElements(this.$nav);
        this.options.navContainer.prepend(this.$nav);
        this.renderSubTemplate(true, this.options.subTemplates.nav, this.$nav, {
            model: this.model,
            options: this.options,
            renderTokens: _.bind(this.renderTokens, this)
        }, _.bind(function () {
            this.$nav.find('.btn-unlock').off().on('click', _.bind(this.unlockPrequal, this));
            this.$nav.find('.btn-lock').off().on('click', _.bind(this.lockPrequal, this));
            this.$nav.find('.prequal-nav-item').on('shown.bs.tab', _.bind(this.navClicked, this));
            this.renderRequestedBy();
            callback();
        }, this));
    },
    renderRequestedBy: function () {
        this.renderSubTemplate(false, this.options.subTemplates.requestedBy, this.$nav.find('.requested-by'), {
            model: this.model,
            isAdmin: this.options.isAdmin
        });
    },
    renderForm: function () {
        this.$('.prequal-header').empty();
        this.$('.prequal-tabs').empty();
        this.contactsGridsAutcompletes = null;

        let headerPref = this.model.preferences.getPref(PJQ.constants.preferenceTypes.PREQUAL_HEADER);
        if (_.size(headerPref) > 0) {
            new PJQ.Alert(this.$('.prequal-header'), {
                text: headerPref,
                isPrepend: true,
                type: 'warning'
            });
        }

        if (!this.options.isAdmin) {
            let alertCookie = null, alertType, helpAlertText;
            if (this.model.get('isLocked')) {
                alertType = 'warning';
                helpAlertText = 'Your prequalification form is currently locked and cannot be changed until it is unlocked by the client'
            } else {
                alertType = 'primary';
                alertCookie = PJQ.constants.cookies.CLOSE_PREQUAL_HELP_ALERT;
                helpAlertText = 'Thank you for updating your Qualification Statement. Please refer to the <a href="javascript:void(0)" class="view-prequal-faq font-weight-normal">FAQ</a> for additional details.'
                if (this.clients.hasItems()) {
                    helpAlertText += '<br /><b>Click "View Requested Criteria" after completing this form.</b>';
                } else if (this.model.get('isRequireSignature')) {
                    let sigAlertPref = this.model.preferences.getPref(PJQ.constants.preferenceTypes.PREQUAL_SIGNATURE_ALERT);
                    if (_.size(sigAlertPref) > 0) {
                        helpAlertText = sigAlertPref;
                    } else {
                        helpAlertText += '<br /><b>Click "Sign and Submit" after completing this form.</b>';
                    }
                }
            }
            new PJQ.Alert(this.$('.prequal-header'), {
                text: helpAlertText,
                type: alertType,
                isPrepend: true,
                cookie: alertCookie
            });

            if (this.options.navContainer != null) {
                this.options.navContainer.parent().find('.btn-export-prequal').animateCSS('slideDown');
            }
        }

        if (this.options.isAdmin) {
            let dp = new PJQ.inputs.Datepicker({
                el: this.$nav.find('.edit-expiration'),
                isShowTimezone: false,
                datePickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                    widgetPositioning: {
                        vertical: 'bottom',
                        horizontal: 'auto'
                    },
                    defaultDate: this.model.get('expiresOn')
                },
                onChange: _.bind(function (expiresOn) {
                    this.model.patch({
                        expiresOn: expiresOn
                    });
                    this.renderExpiration();
                    dp.hide();
                }, this)
            });
        }
        this.renderExpiration();

        if (this.model.get('isRequireSignature')) {
            this.renderSigned();
        }

        //Render all of the tabs
        this.formulaFields = {};
        this.tabChanged();

        this.fillDefaults();

        _.each(_.sortBy(_.filter(this.model.tabs, function (tab) {
            let tabFields = _.filter(tab.fields, function (field) {
                if (field.isHidden || (field.isAdmin && !this.options.isAdmin)) {
                    return false;
                }

                if (this.options.isAdmin && _.size(field.allowedUserTypeIds) > 0) {
                    return field.allowedUserTypeIds.indexOf(PJQ.app.session.user.get('userTypeId')) !== -1;
                }

                return true;
            }, this);
            return _.size(tabFields) > 0 && !tab.isHidden
        }, this), function (tab) {
            return tab.sortOrder
        }), _.bind(function (tab, index) {
            this.renderSubTemplate(true, this.options.subTemplates.tab, this.$('.prequal-tabs'), {
                index: index,
                tab: tab
            });

            let tabEl = this.getTabElement(tab.prequalTabId);
            if (_.size(tab.note) > 0) {
                new PJQ.Alert(tabEl, {
                    text: tab.note,
                    isPrepend: true
                });
            }

            //Render all of the fields for this tab
            _.each(_.sortBy(tab.fields, function (field) {
                return field.sortOrder;
            }), _.bind(function (field) {
                let fnParsed = this.parseFormula(field);
                if (_.size(fnParsed.args) > 0) {
                    _.each(fnParsed.args, function (arg) {
                        if (arg != null && arg.indexOf('[') !== -1) {
                            let cfId = parseInt(arg.replace('[', '').replace(']', ''));
                            this.formulaFields[cfId] = _.uniq(_.union(this.formulaFields[cfId], [field.prequalFieldId]));
                        }
                    }, this);
                }

                // don't render the field, but we want to add it as a formula field above
                if (field.isHidden || (field.isAdmin && !this.options.isAdmin)
                    || (this.options.isAdmin && _.size(field.allowedUserTypeIds) > 0 && field.allowedUserTypeIds.indexOf(PJQ.app.session.user.get('userTypeId')) === -1)) {
                    return;
                }

                let fieldDestination = tabEl;
                if (field.category.length > 0) {
                    let categoryId = this.model.categories.indexOf(field.category);
                    if (categoryId < 0) {
                        this.model.categories.push(field.category);
                        categoryId = this.model.categories.indexOf(field.category);
                    }
                    if (this.getCategoryElement(tab.prequalTabId, categoryId).length === 0) {
                        this.renderSubTemplate(true, this.options.subTemplates.fieldCategory, fieldDestination, {
                            category: this.renderTokens(field.category),
                            categoryId: categoryId
                        });
                    }
                    fieldDestination = this.getCategoryElement(tab.prequalTabId, categoryId);
                }

                let overrideCanEdit = false;
                if (!this.options.canEdit && _.size(field.adminUserTypeIds) > 0 && field.adminUserTypeIds.indexOf(PJQ.app.session.user.get('userTypeId')) !== -1) {
                    overrideCanEdit = true;
                }

                // If the user has changed the amount of project references required, we need to replace any reference to 3 (default value) to the new required amount.
                if (field.coreFieldName.toLowerCase() === 'projectreferences' && this.model.preferences.hasPref(PJQ.constants.preferenceTypes.PREQUAL_PROJECT_REFERENCE_COUNT)) {
                    let refCount = this.model.preferences.getPref(PJQ.constants.preferenceTypes.PREQUAL_PROJECT_REFERENCE_COUNT);
                    field.description = field.description.replace("three (3)", (PJQ.helpers.formatHelpers.numberToWords(refCount)) + ' (' + (refCount) + ')').replace("3", refCount);
                }

                this.renderSubTemplate(true, this.options.subTemplates.field, fieldDestination, {
                    field: field,
                    isAdmin: this.options.isAdmin === true,
                    subTemplates: this.options.subTemplates,
                    renderTokens: _.bind(this.renderTokens, this),
                    canEdit: this.options.canEdit || overrideCanEdit
                });

                if (field.coreFieldName.toLowerCase() === 'federaltaxid' && this.model.preferences.hasPref(PJQ.constants.preferenceTypes.PREQUAL_TAX_ID_MASK)) {
                    $(fieldDestination).find('input[data-p-bind="federalTaxId"]').inputmask(this.model.preferences.getPref(PJQ.constants.preferenceTypes.PREQUAL_TAX_ID_MASK), {
                        placeholder: ''
                    });
                }

                if (field.coreFieldName.toLowerCase() === 'otheroffices')
                    this.renderOtherOffices(field);
                else if (field.coreFieldName.toLowerCase() === 'ownercontacts')
                    this.renderOwnerContacts(field);
                else if (field.coreFieldName.toLowerCase() === 'operationscontacts')
                    this.renderOperationsContacts(field);
                else if (field.coreFieldName.toLowerCase() === 'estimatingcontacts')
                    this.renderEstimatingContacts(field);
                else if (field.coreFieldName.toLowerCase() === 'safetycontacts')
                    this.renderSafetyContacts(field);
                else if (field.coreFieldName.toLowerCase() === 'projectreferences')
                    this.renderProjectReferences(field);
            }, this));
        }, this));
        this.renderGroups();
        this.renderRegions();
        this.attachFormEvents();
        this.updateCalcFields();
        this.updateFormulaFields();
        this.validateForm();
        if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DODGE_CRM) && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DODGE_WG)) {
            this.$('.network-upgrade,.edit-profile').removeClass('hidden');
        }
        this.updateLastSavedDate();

        //Update the prequal form percent complete on first load - we want to be sure this is up to date in the database as much as possible
        this.model.patch({
            completionData: this.model.getCompletionData(),
            percentComplete: this.model.get('percentComplete'),
            masterUserId: this.model.get('masterUserId')
        });
    },
    renderExpiration: function () {
        let expiresOn = this.model.get('expiresOn'),
            $expiresOn = this.$nav.find('.prequal-expires-on');
        if (expiresOn != null) {
            let expiresOnDate = new Date(expiresOn);
            $expiresOn.text(PJQ.helpers.dateHelpers.getDateString(expiresOnDate, PJQ.helpers.dateHelpers.dateFormats.DATE)).css({
                color: PJQ.helpers.dateHelpers.checkDateIsBeforeToday(expiresOnDate) ? PJQ.constants.colors.RED : PJQ.constants.colors.GREEN
            });
        } else {
            $expiresOn.text("Not Set").css({
                color: PJQ.constants.colors.RED
            });
        }
    },
    renderSigned: function () {
        let signedOn = this.model.get('signedOn'),
            $signedOn = this.$nav.find('.prequal-signed-on');
        if (signedOn != null) {
            $signedOn.text(PJQ.helpers.dateHelpers.getDateString(new Date(signedOn), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME)).css({
                color: PJQ.constants.colors.GREEN
            });
        } else {
            $signedOn.text("Never").css({
                color: PJQ.constants.colors.RED
            });
        }
    },
    continue: function () {
        let requireSignature = this.model.get('isRequireSignature'),
            hasScreenings = this.clients.hasItems();
        if (requireSignature) {
            let terms = this.model.preferences.getPref(PJQ.constants.preferenceTypes.PREQUAL_TERMS),
                onSubmit = _.bind(function (signature, callback) {
                    this.model.sign(signature, _.bind(function () {
                        if (hasScreenings) {
                            this.viewScreenings();
                            this.renderSigned();
                        } else if (this.model.get('isLocked')) {
                            this.render();
                        } else {
                            this.renderSigned();
                        }
                        PJQ.notifications.notify.successNotify({
                            message: 'Qualification Statement signed'
                        });
                        callback();
                    }, this));
                }, this);
            if (terms != null) {
                new PJQ.views.signatures.SignatureTermsModal({
                    terms: terms,
                    onSubmit: onSubmit,
                    fitHeight: false
                });
            } else {
                new PJQ.views.signatures.SignatureSubmitModal({
                    onSubmit: onSubmit
                });
            }
        } else if (hasScreenings) {
            this.viewScreenings();
        }
    },
    viewScreenings: function () {
        let fnView = _.bind(function () {
            if (this.options.dashboard) {
                this.options.dashboard.renderClientScreenings();
            } else {
                window.location = (window.location.href.toLowerCase().substring(0, window.location.href.toLowerCase().indexOf('&')) + '&sId=' + pjqScreeningAccessKey);
            }
        }, this);
        if (_.size(this.model.dirtyAttributes) > 0) {
            this.model.patch({
                prequalCoreId: this.model.id,
                masterUserId: this.model.get('masterUserId')
            }, {
                success: _.bind(function () {
                    fnView();
                }, this)
            });
        } else {
            fnView();
        }
    },
    updateViewScreeningButton() {
        let requireSignature = this.model.get('isRequireSignature');
        if (requireSignature) {
            let screeningButton = this.$('.btn-continue'),
                allowSignatureAlways = this.model.preferences.getPref(PJQ.constants.preferenceTypes.PREQUAL_ALLOW_SIGNATURE_ALWAYS);
            screeningButton.removeClass('hidden');
            if (this.model.get("percentComplete") < 100 && !allowSignatureAlways) {
                screeningButton.prop('disabled', true);
            } else {
                screeningButton.prop('disabled', false);
            }

            screeningButton.text("Sign and Submit");
        }
    },
    attachFormEvents: function () {
        let self = this;
        this.selectPickers = {};
        //Init select inputs and attach events
        this.$('.input-select[data-p-bind],.input-bool[data-p-bind]').each(function () {
            let input = $(this),
                fieldId = input.data('fieldId'),
                field = self.model.fields[fieldId],
                attribute = input.data('pBind') ? input.data('pBind') : '',
                isContactInput = attribute.indexOf('contact.') !== -1,
                isABCustomField = attribute.indexOf('contact.cf_') !== -1 || attribute.indexOf('contact.ccf_') !== -1,
                selectPicker = new PJQ.inputs.Selectpicker({
                    el: input,
                    isIntChoices: !input.hasClass('input-bool') && !input.hasClass('input-state') && (isABCustomField || !isContactInput) && attribute.toLowerCase() !== 'isunion|isnonunion',
                    exclusiveChoices: _.map(_.where(field.choices, {isExclusive: true}), function (choice) {
                        return choice.prequalFieldChoiceId;
                    }),
                    onChange: function (value) {
                        if (input.hasClass('input-bool')) {
                            if (_.size(value) > 0) {
                                value = value.toLowerCase() === 'true';
                            } else {
                                value = null;
                            }
                        }

                        //Custom logic for contact state/country
                        if (isContactInput) {
                            if (attribute.toLowerCase() === 'contact.country') {
                                self.renderContactStateCountyPickers(value);
                            }
                        }

                        self.prequalChanged(input, value);
                    }
                });

            if (attribute.toLowerCase() === 'contact.state') {
                self.contactStatePicker = selectPicker;
            } else {
                let fieldId = input.data('fieldId');
                self.selectPickers[fieldId] = selectPicker;
            }
        });
        this.renderContactStateCountyPickers(this.model.contact.get('country'));

        this.$('.input-date[data-p-bind],.input-date-time[data-p-bind]').each(function () {
            let fieldEl = $(this),
                isDateTime = $(this).hasClass('.input-date-time');
            new PJQ.inputs.Datepicker({
                el: fieldEl,
                datepickerOptions: {
                    format: !isDateTime ? PJQ.helpers.dateHelpers.dateFormats.DATE.toUpperCase() : undefined
                },
                onChange: function (value) {
                    self.prequalChanged(fieldEl, value);
                }
            });
        });

        this.$('.input-file-upload').each(function () {
            let $input = $(this),
                field = self.model.fields[$input.data('fieldId')],
                fnInput = function (attachments) {
                    let endpoint,
                        screeningItemId = field.relatedScreeningItemId;
                    if (screeningItemId > 0) {
                        endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                                {
                                    endpoint: 'contacts',
                                    value: self.options.contact != null ? self.options.contact.id : PJQ.app.session.contact.id
                                },
                                {
                                    endpoint: 'screenings'
                                },
                                {
                                    endpoint: 'items',
                                    value: screeningItemId
                                },
                                {
                                    endpoint: 'attachments'
                                }
                            ],
                            [
                                {
                                    parameter: 'masterUserId',
                                    value: self.model.get('masterUserId')
                                }
                            ]);
                    } else {
                        let params;
                        if (self.model.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_PREQUAL_CONTACT_ATTACHMENT_LINK)) {
                            params = [
                                {
                                    parameter: 'fromPrequal',
                                    value: true
                                }
                            ];
                        } else {
                            params = null
                        }

                        endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'contacts',
                                value: self.options.contact != null ? self.options.contact.id : PJQ.app.session.contact.id
                            },
                            {
                                endpoint: 'attachments'
                            }
                        ], params);
                    }

                    let overrideCanEdit = false;
                    if (!self.options.canEdit && _.size(field.adminUserTypeIds) > 0 && field.adminUserTypeIds.indexOf(PJQ.app.session.user.get('userTypeId')) !== -1) {
                        overrideCanEdit = true;
                    }
                    new PJQ.views.files.FileUploaderGrid({
                        el: $input,
                        canUpload: (self.options.canEdit || overrideCanEdit),
                        canDelete: !(screeningItemId > 0) && (self.options.canEdit || overrideCanEdit) && (self.options.isAdmin || overrideCanEdit || !self.model.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_PREQUAL_ATTACHMENT_DELETE)),
                        collection: attachments,
                        endpoint: endpoint,
                        onSuccess: function (file) {
                            if (!(screeningItemId > 0)) {
                                let guids = [file.guid];
                                if (attachments != null) {
                                    _.each(attachments.models, function (attachment) {
                                        if (_.size(attachment.get('guid')) > 0) {
                                            guids.push(attachment.get('guid'));
                                        }
                                    });
                                }
                                self.prequalChanged($input, guids);
                            } else if (file.fileData != null) {
                                let fieldId = $input.data('fieldId'),
                                    tab = self.getFieldTab(fieldId),
                                    field = _.findWhere(tab.fields, {
                                        prequalFieldId: fieldId
                                    });
                                if (field != null) {
                                    field.isValid = true;
                                    self.prequalChanged($input, field.fieldValue);
                                }
                            }
                        },
                        onDelete: function (file, callback) {
                            let guids = [],
                                delAttachments = [];
                            if (attachments != null) {
                                _.each(attachments.models, function (attachment) {
                                    if (_.size(attachment.get('guid')) > 0 && file.get('guid') !== attachment.get('guid')) {
                                        guids.push(attachment.get('guid'));
                                    } else {
                                        delAttachments.push(attachment);
                                    }
                                });
                                attachments.remove(delAttachments);
                            }
                            self.prequalChanged($input, guids);
                            callback();
                        }
                    });
                };
            if (_.size(field.fieldValue) > 0) {
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'files'
                        },
                        {
                            endpoint: 'details'
                        }
                    ]),
                    data: {
                        guids: field.fieldValue ? ((typeof field.fieldValue === 'string') ? field.fieldValue.split('|') : field.fieldValue) : null
                    }
                }).post().done(_.bind(function (result) {
                    let attachments = new PJQ.collections.files.Files(result);
                    fnInput(attachments);
                }, this));
            } else {
                fnInput(new PJQ.collections.files.Files());
            }
        });

        //Init the binder but override the change event
        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input',
                'textarea'
            ],
            onChange: _.bind(function (changeEl, attribute, value) {
                this.prequalChanged(changeEl, value);
            }, this)
        });

        this.$('.input-dollars-full[data-p-bind],.input-numeric[data-p-bind],.input-percent[data-p-bind]').each(function () {
            let input = $(this),
                field = self.model.fields[input.data('fieldId')];

            if (field.numericMinValue != null || field.numericMaxValue != null) {
                PJQ.helpers.inputHelpers.attachNumericInputMinMax(input, field.numericMinValue, field.numericMaxValue, function () {
                    input.trigger('keyup');
                });
            }
        });
        PJQ.helpers.inputHelpers.inputMaskCurrency(this.$('.input-dollars-full'), 2);
        PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.input-phone'));
    },
    renderContactStateCountyPickers: function (country) {
        let states = PJQ.constants.states.us;
        if (country.toLowerCase() === 'ca') {
            states = PJQ.constants.states.ca;
        }
        if (this.contactStatePicker) {
            this.contactStatePicker.updateChoices(_.union([""], _.map(states, function (state) {
                return state.abbreviation;
            })));
            this.contactStatePicker.setValue(this.model.contact.get('state'));
        }
    },
    getNewDateAddMonths: function (date, months) {
        if (date == null) {
            return null;
        }

        let dt = new Date(date);
        if (months > 0) {
            return new moment(dt).add(months, 'months').format('MM/DD/YYYY');
        } else {
            return new moment(dt).format('MM/DD/YYYY');
        }
    },
    checkFieldValueChanged: function (fieldType, currentValue, newValue) {
        let hasChanged;
        switch (fieldType.toLowerCase()) {
            case 'int':
            case 'money':
            case 'percent':
            case 'state':
            case 'text':
            case 'textarea':
            case 'phone':
            case 'bool':
                hasChanged = currentValue == null || currentValue !== newValue;
                break;
            case 'choice':
            case 'upload':
            case 'date':
            case 'grid':
            case 'groupselect':
            case 'regionselect':
            default:
                // any change event on these fields is assumed to be a data change
                hasChanged = true;
                break;
        }
        return hasChanged;
    },
    prequalChanged: function (input, value, fId = null, isUpdate = true) {
        let attribute, fieldId;
        if (fId > 0) {
            fieldId = fId;
            if (_.size(input) === 0) {
                input = this.getFieldElement(fieldId);
            }
        } else {
            fieldId = input.data('fieldId');
        }

        let tab = this.getFieldTab(fieldId);
        if (tab == null) {
            return;
        }

        let field = _.findWhere(tab.fields, {
                prequalFieldId: fieldId
            }),
            fieldType = field.fieldType.toLowerCase();

        if (_.size(input) > 0) {
            attribute = input.data('pBind');
        } else if (field != null) {
            if (field.fieldNumber > 0) {
                attribute = "cf_" + field.fieldNumber.toString();
            } else if (_.size(field.coreFieldName) > 0) {
                attribute = field.coreFieldName.toLowerCase();
            }
        }

        if (_.size(attribute) === 0 || fieldId == null) {
            if(tab && field) {
                this.queueValidation(tab, field, isUpdate);
            }
            return;
        }

        if (fieldType === "percent" && value > 0) {
            value = value / 100;
        }

        value = value != null ? value : "";

        //Check if the changed value is for a grid field - if its a grid the attribute will be null
        if (attribute != null) {
            if (this.model.attributes.patchValues == null) {
                this.model.attributes.patchValues = [];
            }

            //Check if the changed value is for a custom field
            if (attribute.indexOf('cf_') > -1) {
                let fnParse = this.parseFormula(field);
                if (typeof fnParse.fn === 'function' && (value == null || _.size(value.toString()) === 0)) {
                    let valArgs = [];
                    _.each(fnParse.args, function (arg) {
                        if (arg != null) {
                            if (arg.indexOf('[') !== -1) {
                                let argId = arg.replace('[', '').replace(']', ''),
                                    argField = this.model.fields[parseInt(argId)];
                                if (argField != null) {
                                    if (argField.fieldType.toLowerCase() === 'bool') {
                                        valArgs.push(argField.fieldValue != null ? argField.fieldValue : '');
                                    } else {
                                        valArgs.push(argField.fieldValue != null ? argField.fieldValue : 0);
                                    }
                                }
                            } else {
                                valArgs.push(arg);
                            }
                        }
                    }, this);
                    value = fnParse.fn(...valArgs);

                    let displayValue;
                    if (value != null && typeof value === 'object' && typeof value.display !== 'undefined') {
                        displayValue = value.display;
                        value = value.value;
                    } else {
                        displayValue = value;
                    }

                    if (fieldType === 'bool' || fieldType === 'choice') {
                        let sp = this.selectPickers[fieldId];
                        if (sp != null) {
                            sp.setValue(displayValue);
                        }
                    } else if (_.size(input) > 0) {
                        let inputVal = displayValue;
                        if (fieldType === 'money') {
                            inputVal = displayValue != null ? parseFloat(displayValue / 100) : '';
                        } else if (fieldType === 'date' || fieldType === 'datetime') {
                            let dateFormat = fieldType === 'date' ? PJQ.helpers.dateHelpers.dateFormats.DATE : PJQ.helpers.dateHelpers.dateFormats.DATE_TIME;
                            inputVal = displayValue != null ? PJQ.helpers.dateHelpers.getDateString(inputVal, dateFormat) : '';
                        }
                        input.val(inputVal);
                    }
                } else if (_.size(fnParse.eval) > 0) {
                    let evl = fnParse.eval;
                    _.each(fnParse.args, function (arg) {
                        if (arg.indexOf('[') !== -1) {
                            let argId = parseInt(arg.replace('[', '').replace(']', '')),
                                fieldTab = this.getFieldTab(argId);
                            if (fieldTab != null) {
                                let argField = _.findWhere(fieldTab.fields, {
                                    prequalFieldId: argId
                                });
                                if (argField != null) {
                                    let flVal = parseFloat(argField.fieldValue);
                                    evl = evl.replace(arg, '(' + (isNaN(flVal) ? 0 : flVal) + ')');
                                }
                            }
                        }
                    }, this);
                    let evalVal = eval(evl);
                    value = isNaN(evalVal) ? 0 : evalVal;

                    if (_.size(input) > 0) {
                        input.val(field.fieldType.toLowerCase() === 'money' ? parseFloat(value / 100) : value);
                    }
                }

                field.fieldValue = value
                let customFields = {};
                if (attribute.indexOf('contact.ccf_') > -1) {
                    let fieldId = parseInt(attribute.replace('contact.ccf_', '')),
                        newValue = {
                            id: fieldId,
                            prequalFieldId: field.prequalFieldId,
                            value: value
                        },
                        currentValue = _.find(this.model.get('companyCustomFieldValues'), function (exValue) {
                            return newValue.id === exValue.id;
                        });
                    if (currentValue != null) {
                        if (!this.checkFieldValueChanged(field.fieldType, currentValue.value, newValue.value)) {
                            return;
                        }
                    }
                    if (typeof this.options.onCompanyCustomFieldChange === 'function') {
                        this.options.onCompanyCustomFieldChange(newValue);
                    }

                    let cfValues = _.filter(this.model.get('companyCustomFieldValues'), function (exValue) {
                        return newValue.id !== exValue.id;
                    });
                    cfValues.push(newValue);
                    this.model.set('companyCustomFieldValues', cfValues);

                    if (this.model.contact != null) {
                        this.model.contact.set('companyCustomFieldValues', cfValues, {silent: true});
                    }
                } else {
                    let customFieldNumber = parseInt(attribute.replace('cf_', ''));
                    if (customFields[customFieldNumber] !== value) {
                        customFields[customFieldNumber] = value;
                        this.model.set('customFieldValues', _.defaults(customFields, this.model.dirtyAttributes.customFieldValues));
                    }
                }

                let calcIds = this.formulaFields[field.prequalFieldId];
                if (_.size(calcIds) > 0) {
                    _.each(calcIds, function (calcId) {
                        if (calcId !== fieldId) {
                            this.prequalChanged(null, null, calcId, isUpdate);
                        }
                    }, this);
                }
            }
            //Check if the changed value is for a contact field
            else if (attribute.indexOf('contact.') > -1) {
                let prop = PJQ.helpers.formatHelpers.lowerCaseFirstLetter(attribute.replace('contact.', ''));
                this.model.contact.set(prop, value);
                this.model.contact.queueSave({}, {}, 800);
                if (typeof this.options.onContactChange === 'function') {
                    this.options.onContactChange(this.model.contact, {
                        prop: prop,
                        value: value
                    });
                }
            }
            //If its not a contact or grid field, then its a prequal core/custom field
            else {
                //Check if the changed value is labor status, if it is set isUnion/isNonUnion accordingly
                if (attribute.toLowerCase() === 'isunion|isnonunion') {
                    let isUnion = _.find(value, function (choice) {
                            return choice.toLowerCase() === 'union';
                        }) != null,
                        isNonUnion = _.find(value, function (choice) {
                            return choice.toLowerCase() === 'non-union';
                        }) != null,
                        laborStatus = {
                            isUnion: isUnion,
                            isNonUnion: isNonUnion
                        };
                    this.model.contact.set(laborStatus);
                    this.model.contact.queueSave({}, {}, 800);
                    if (typeof this.options.onContactChange === 'function') {
                        this.options.onContactChange(this.model.contact, {
                            prop: 'isUnion',
                            value: isUnion
                        });
                        this.options.onContactChange(this.model.contact, {
                            prop: 'isNonUnion',
                            value: isNonUnion
                        });
                    }

                    this.model.set(laborStatus);
                } else {
                    //Set the value for the core model
                    this.model.set(attribute, value);

                    // we are only using the patchValues property for boolean and choice at the moment
                    // it works for every type of value, but has not been tested for production on anything but boolean and choice
                    // this is to fix the issue where the API doesnt know that a boolean or choice value has been updated to null
                    // the API expects that supplying null in the request model means that the value was not updated
                    if (fieldType === 'bool') {
                        value = typeof value === 'boolean' ? value : "";
                        if (typeof value === 'string' && _.size(value) > 0) {
                            value = value.toLowerCase() === 'true';
                        } else if (typeof value !== 'boolean') {
                            value = null;
                        }

                        this.model.addPatchValue({
                            attribute: attribute,
                            value: value
                        });
                    } else if (fieldType === 'choice' && value == null) {
                        this.model.addPatchValue({
                            attribute: attribute,
                            value: _.size(value) > 0 || typeof value === 'number' ? value : null
                        });
                    }
                }
            }

            // We must now apply the same value as above to the field and tab structure which is used for easier rendering and validating
            field.fieldValue = value;

            //It is a custom field
            if (field.fieldNumber > 0) {
                if (field.fieldType.toLowerCase() === 'int') {
                    this.updateCalcFields(field);
                }
            }
        } else {
            //If the attribute is null, it could be one of the grids
            if (_.size(field.coreFieldName) > 0) {
                if (field.fieldType.toLowerCase() === 'grid' && field.coreFieldName.toLowerCase().indexOf("contact") !== -1) {
                    this.renderContactsGridsAutocompletes();
                }
            }
        }

        this.queueValidation(tab, field, isUpdate);
    },
    parseFormula: function (field) {
        let result = {
            fn: null,
            eval: null,
            args: null
        };
        if (_.size(field.formula) > 0) {
            if (field.formula.indexOf('eval_') !== -1) {
                result.args = [];
                field.formula.replace(/\[(.*?)\]/g, function (g0, g1) {
                    result.args.push('[' + g1 + ']');
                });
                result.eval = field.formula.replace('eval_', '');
            } else {
                let sp = field.formula.split('(');
                if (_.size(sp) === 2) {
                    if (field.formula.indexOf('fn_') !== -1) {
                        if (PJQ.helpers.objectHelpers.checkNested(PJQ.app, 'portal', 'customization', 'prequal', 'formulas')) {
                            result.fn = PJQ.app.portal.customization.prequal.formulas[sp[0].replace('fn_', '')];
                        } else {
                            result.fn = _.noop;
                        }
                    } else if (field.formula.indexOf('monthadd_') !== -1) {
                        result.fn = this.getNewDateAddMonths;
                    } else if (field.formula.indexOf('helper_') !== -1) {
                        result.fn = PJQ.helpers.prequalHelpers[sp[0].replace('helper_', '')];
                    }
                    if (typeof result.fn === 'function') {
                        result.args = sp[1].replace(')', '').replace(/\s/g, '').split(',');
                    }
                }
            }
        }
        return result;
    },
    queueValidation: function (tab, field, isUpdate = true) {
        //Set a timeout for validation
        //if a user is inputting data in a text field, this will execute on keyup and that is too much for the browser to handle
        clearTimeout(this.validateTimeout);
        this.validateQueue = this.validateQueue != null ? this.validateQueue : [];
        if (_.findWhere(this.validateQueue, {
            prequalTabId: tab.prequalTabId,
            prequalFieldId: field ? field.prequalFieldId : null
        }) == null)
            this.validateQueue.push({
                tab: tab,
                field: field
            });
        this.validateTimeout = setTimeout(_.bind(function () {
            _.each(this.validateQueue, _.bind(function (queueItem) {
                this.validateForm(queueItem.tab, queueItem.field);
            }, this));
            this.validateQueue = [];

            this.model.queueSave({
                prequalCoreId: this.model.id,
                masterUserId: this.model.get('masterUserId')
            }, {
                isPatch: true,
                success: _.bind(function () {
                    if (isUpdate) {
                        this.model.set('modifiedOn', new Date(), {silent: true});
                        this.updateLastSavedDate();
                    }
                }, this)
            }, 800);
        }, this), 300);
    },
    validateForm: function (inputTab, inputField) {
        //validates the form, calculates its completion, and renders field constraints
        this.model.completionData = this.model.completionData ? this.model.completionData : {};
        if (this.validationData == null) {
            this.validationData = {
                tabs: {},
                progress: 0
            };
        }
        _.each(_.filter(this.model.tabs, function (filterTab) {
            if (inputTab == null || (inputTab.prequalTabId === filterTab.prequalTabId && !filterTab.isHidden)) {
                return null != _.find(filterTab.fields, function (filterField) {
                    if (filterField.isAdmin && !this.options.isAdmin) {
                        return false;
                    } else if (this.options.isAdmin && _.size(filterField.allowedUserTypeIds) > 0) {
                        return filterField.allowedUserTypeIds.indexOf(PJQ.app.session.user.get('userTypeId')) !== -1;
                    }
                    return true;
                }, this);
            }
        }, this), _.bind(function (tabObj) {
            if (this.validationData.tabs[tabObj.prequalTabId] == null) {
                this.validationData.tabs[tabObj.prequalTabId] = {
                    fields: {},
                    tab: tabObj,
                    progress: 0,
                    isCalculate: tabObj.isCalculate
                }
            }
            let validationTab = this.validationData.tabs[tabObj.prequalTabId];
            _.each(_.filter(tabObj.fields, function (field) {
                return inputField == null || inputField.prequalFieldId === field.prequalFieldId;
            }, this), _.bind(function (field) {
                if (!field.isHidden && field.isRequired) {
                    if (!this.model.checkConstraintsMet(field)) {
                        validationTab.fields = _.omit(validationTab.fields, function (omitField) {
                            return omitField.field.prequalFieldId === field.prequalFieldId;
                        });
                    } else {
                        validationTab.fields[field.prequalFieldId] = {
                            field: field,
                            isValid: this.validateField(tabObj, field),
                            isAdmin: field.isAdmin
                        };
                    }
                }
                this.renderFieldConstraints(field);
            }, this));
            let fieldCount = _.size(validationTab.fields),
                externalFieldCount = _.size(_.where(validationTab.fields, {
                    isAdmin: false
                }));
            if (fieldCount === 0) {
                validationTab.progress = 100;
                validationTab.saveProgress = 100;
            } else {
                if(externalFieldCount === 0){
                    validationTab.saveProgress = 100;
                } else{
                    validationTab.saveProgress = Math.floor((_.size(_.where(validationTab.fields, {
                        isValid: true,
                        isAdmin: false
                    })) / externalFieldCount) * 100);
                }

                if (this.options.isAdmin) {
                    validationTab.progress = Math.floor((_.size(_.where(validationTab.fields, {
                        isValid: true
                    })) / fieldCount) * 100);
                } else {
                    validationTab.progress = validationTab.saveProgress;
                }
            }
        }, this));
        this.model.completionData.tabs = this.validationData.tabs = _.defaults(this.validationData.tabs, this.model.completionData.tabs ? this.model.completionData.tabs : {});

        let viewTotal = 0,
            saveTotal = 0,
            calcTabCount = 0;
        _.each(this.validationData.tabs, function (tab) {
            if (tab.isCalculate !== false) {
                saveTotal += tab.saveProgress;
                calcTabCount++;
            }
            viewTotal += this.options.isAdmin ? tab.progress : tab.saveProgress;
        }, this);
        this.validationData.progress = Math.floor(viewTotal / _.size(this.validationData.tabs));

        if (inputTab == null) {
            this.initCalculationDone = true;
        }

        let percentComplete = Math.floor(saveTotal / calcTabCount);
        if ((typeof this.initCalculationDone === 'boolean' && this.initCalculationDone) && this.model.get('percentComplete') < 100 && percentComplete >= 100 && this.clients != null && this.clients.hasItems()) {
            let notificationText;
            if (this.model.get('isRequireSignature')) {
                notificationText = 'Please click "Sign and Submit" when you are ready to proceed.  After signing, click "View Requested Criteria" to continue submitting requested items.';
            } else {
                notificationText = 'Please click "View Requested Criteria" when you are ready to proceed.';
            }
            PJQ.notifications.createNotifyModal({
                header: 'Your prequal is 100% complete',
                notification: notificationText,
                cookie: PJQ.constants.cookies.NOTIFY_PREQUAL_VIEW_REQUESTED
            });
        }

        let cData = {
            tabs: _.map(this.model.completionData.tabs, (calc) => {
                return {
                    id: calc.tab.prequalTabId,
                    progress: calc.progress
                };
            })
        };
        this.model.set({
            completionData: this.model.getCompletionData(),
            percentComplete: percentComplete
        });
        this.hideEmptyCategories();
        this.hideEmptyTabs();
        this.renderCompletion(this.validationData);
        this.updateViewScreeningButton();
    },
    validateField: function (tab, field) {
        if (!field.isRequired || field.isValid)
            return true;

        let isValid = false;
        switch (field.fieldType.toLowerCase()) {
            case 'upload':
                isValid = field.fieldValue != null && _.size(field.fieldValue) > 0;
                break;
            case 'int':
            case 'money':
            case 'percent':
                isValid = field.fieldValue != null && !isNaN(parseFloat(field.fieldValue));
                break;
            case 'state':
                isValid = _.size(field.fieldValue) > 0;
                break;
            case 'choice':
                isValid = field.fieldValue != null && ((!isNaN(field.fieldValue) && field.fieldValue > 0) || _.size(field.fieldValue) > 0);
                break;
            case 'text':
            case 'textarea':
            case 'phone':
                isValid = field.fieldValue != null && field.fieldValue.toString().trim().length > 0;

                if (field.coreFieldName.toLowerCase() === 'federaltaxid' && this.model.preferences.hasPref(PJQ.constants.preferenceTypes.PREQUAL_TAX_ID_MASK)) {
                    isValid = field.fieldValue != null && field.fieldValue.toString().trim().length === 9;
                }
                break;
            case 'date':
                isValid = typeof field.fieldValue === 'object' || _.size(field.fieldValue) > 0;
                break;
            case 'bool':
                isValid = (field.fieldValue === true || field.fieldValue === false);
                break;
            case 'grid':
                if (field.coreFieldName.toLowerCase() === 'otheroffices') {
                    isValid = _.size(_.filter(this.model.otherOffices.models, _.bind(function (office) {
                        let row = this.$('div[data-cid=' + office.cid + ']'),
                            isCityValid = office.get('city').trim().length > 0,
                            isStateValid = office.get('stateProvince').length > 0,
                            isZipValid = office.get('postalCode').trim().length > 0;
                        PJQ.helpers.inputHelpers.setInputError(row.find('.other-office-city'), isCityValid);
                        PJQ.helpers.inputHelpers.setInputError(row.find('select.other-office-state'), isStateValid);
                        PJQ.helpers.inputHelpers.setInputError(row.find('.other-office-zip'), isZipValid);
                        return isCityValid && isStateValid && isZipValid;
                    }, this))) >= 1;

                    let fieldEl = this.getFieldElement(field.prequalFieldId);
                    fieldEl.find('.alert').remove();
                    if (!isValid && this.options.canEdit) {
                        new PJQ.Alert(fieldEl, {
                            type: 'danger',
                            text: 'You must include at least one (1) valid office.',
                            isPrepend: true
                        });
                    }
                } else if (field.coreFieldName.toLowerCase() === 'ownercontacts' || field.coreFieldName.toLowerCase() === 'operationscontacts' || field.coreFieldName.toLowerCase() === 'estimatingcontacts' || field.coreFieldName.toLowerCase() === 'safetycontacts') {
                    let contacts;
                    if (field.coreFieldName.toLowerCase() === 'ownercontacts') {
                        contacts = this.model.ownerContacts;
                    } else if (field.coreFieldName.toLowerCase() === 'operationscontacts') {
                        contacts = this.model.operationsContacts;
                    } else if (field.coreFieldName.toLowerCase() === 'estimatingcontacts') {
                        contacts = this.model.estimatingContacts;
                    } else if (field.coreFieldName.toLowerCase() === 'safetycontacts') {
                        contacts = this.model.safetyContacts;
                    }
                    isValid = _.size(_.filter(contacts.models, _.bind(function (contact) {
                        let row = $('div[data-cid=' + contact.cid + ']'),
                            isContactNameValid = contact.get('contactName').length > 0,
                            isEmailValid = contact.get('email').trim().length > 0,
                            isPhoneValid = contact.get('phone').length > 0;
                        PJQ.helpers.inputHelpers.setInputError(row.find('.contact-name'), isContactNameValid);
                        PJQ.helpers.inputHelpers.setInputError(row.find('.contact-email'), isEmailValid);
                        PJQ.helpers.inputHelpers.setInputError(row.find('.contact-phone'), isPhoneValid);
                        if (field.coreFieldName.toLowerCase() === 'ownercontacts') {
                            let isTitleValid = contact.get('contactTitle').length > 0;
                            PJQ.helpers.inputHelpers.setInputError(row.find('.contact-title'), isTitleValid);
                            return isContactNameValid && isEmailValid && isPhoneValid && isTitleValid;
                        } else {
                            return isContactNameValid && isEmailValid && isPhoneValid;
                        }
                    }, this))) >= 1;

                    let fieldEl = this.getFieldElement(field.prequalFieldId);
                    fieldEl.find('.alert').remove();
                    if (!isValid && this.options.canEdit) {
                        new PJQ.Alert(fieldEl, {
                            type: 'danger',
                            text: 'You must include at least one (1) valid contact.',
                            isPrepend: true
                        });
                    }
                } else if (field.coreFieldName.toLowerCase() === 'projectreferences') {
                    let projectReferenceRequirementCount = this.model.preferences.hasPref(PJQ.constants.preferenceTypes.PREQUAL_PROJECT_REFERENCE_COUNT) ? this.model.preferences.getPref(PJQ.constants.preferenceTypes.PREQUAL_PROJECT_REFERENCE_COUNT) : 3
                    isValid = _.size(_.filter(this.model.projectReferences.models, function (reference) {
                        return reference.checkIsRecent();
                    })) >= 3;

                    isValid = _.size(_.filter(this.model.projectReferences.models, _.bind(function (reference) {
                        if (!reference.checkIsRecent())
                            return false;

                        let row = $('div[data-cid=' + reference.cid + ']'),
                            isGCValid = reference.get('generalContractor').trim().length > 0,
                            isGCContactValid = reference.get('generalContractorContactName').trim().length > 0,
                            isGCPhoneValid = reference.get('generalContractorContactPhone').trim().length > 0,
                            isProjectNameValid = reference.get('projectName').trim().length > 0,
                            isDateCompletedValid = reference.get('dateCompleted') !== null,
                            isContractValueValid = reference.get('contractValue') > 0;
                        PJQ.helpers.inputHelpers.setInputError(row.find('.project-reference-gc'), isGCValid);
                        PJQ.helpers.inputHelpers.setInputError(row.find('.project-reference-gc-contact'), isGCContactValid);
                        PJQ.helpers.inputHelpers.setInputError(row.find('.project-reference-gc-phone'), isGCPhoneValid);
                        PJQ.helpers.inputHelpers.setInputError(row.find('.project-reference-gc-email'), isGCPhoneValid);
                        PJQ.helpers.inputHelpers.setInputError(row.find('.project-reference-project-name'), isProjectNameValid);
                        PJQ.helpers.inputHelpers.setInputError(row.find('.project-reference-date-completed'), isDateCompletedValid);
                        PJQ.helpers.inputHelpers.setInputError(row.find('.project-reference-contract-value'), isContractValueValid);
                        return isGCValid && isGCContactValid && isGCPhoneValid && isProjectNameValid && isDateCompletedValid && isContractValueValid;
                    }, this))) >= projectReferenceRequirementCount;

                    let fieldEl = this.getFieldElement(field.prequalFieldId);
                    fieldEl.find('.alert').remove();
                    if (!isValid && this.options.canEdit) {
                        new PJQ.Alert(fieldEl, {
                            type: 'danger',
                            text: 'You must include at least ' + (PJQ.helpers.formatHelpers.numberToWords(projectReferenceRequirementCount)) + ' (' + (projectReferenceRequirementCount) + ')' +  ' valid references.',
                            isPrepend: true
                        });
                    }
                }
                break;
            case 'groupselect':
                isValid = _.find(this.model.contact.groups.models, function (model) {
                    return model.get('isDeleted') !== true
                }) != null;
                break;
            case 'regionselect':
                isValid = _.size(this.model.contact.workAreas.models) > 0;
                break;
        }
        this.updateFieldValidationState(field, isValid);
        return isValid;
    },
    updateFieldValidationState: function (field, isValid) {
        if (!this.options.canEdit) {
            return;
        }

        let fieldEl = this.getFieldElement(field.prequalFieldId);
        switch (field.fieldType.toLowerCase()) {
            case 'groupselect':
                //todo: show validation error for groups
                break;
            case 'regionselect':
                //todo: show validation error for regions
                break;
            default:
                PJQ.helpers.inputHelpers.setInputError(fieldEl, isValid);
                break;
        }
    },
    renderFieldConstraints: function (field) {
        if (!field.constraints || field.constraints.length === 0)
            return;
        //Loop through all of the fields which are controlled by this field
        _.each(_.where(field.constraints, {controlledByCustomFieldId: field.prequalFieldId}), _.bind(function (control) {
            //We cant loop through the constraints on the controller custom field because the custom field being controlled may have other constraints
            //So instead we check all of the fields which this constraint field relies on
            let controlField = this.model.fields[control.customFieldId],
                fieldContainer = this.getFieldElement(controlField.prequalFieldId).closest('.prequal-field-container');
            if (this.model.checkConstraintsMet(controlField)) {
                fieldContainer.removeClass('hidden');
            } else {
                fieldContainer.addClass('hidden');
            }
            this.validateForm(this.getFieldTab(controlField.prequalFieldId), controlField);
        }, this));
    },
    hideEmptyCategories: function () {
        _.each(this.$('.prequal-category-container'), function (categoryEl) {
            let $category = $(categoryEl);
            if (_.size($category.find('.prequal-field-container:not(.hidden):not(.admin-field)')) === 0) {
                $category.addClass('hidden');
            } else {
                $category.removeClass('hidden');
            }
        });
    },
    hideEmptyTabs: function () {
        _.each(this.$('.prequal-tab'), function (tabEl) {
            let $tab = $(tabEl),
                $menuItem = $('.nav-link[data-nav-tab-id="' + $tab.data('tabId').toString() + '"]');
            if (_.size($tab.find('.prequal-field-container:not(.hidden):not(.admin-field)')) === 0) {
                $menuItem.addClass('hidden');
            } else {
                $menuItem.removeClass('hidden');
            }
        }, this);
    },
    renderCompletion: function (data) {
        _.each(data.tabs, _.bind(function (tabObj) {
            let navItem = this.getTabNavElement(tabObj.tab.prequalTabId);
            navItem.find('.prequal-complete-badge').remove();
            navItem.prepend(this.makeCompletionBadge(tabObj.progress));
        }, this));
        this.$('.prequal-complete-text').remove();

        let colorClass = this.getCompletionColorClass(data.progress);
        if (this.totalProgressBar == null) {
            this.totalProgressBar = new PJQ.progress.ProgressBar(this.$nav.find('.prequal-progress'), {
                isShowPercentage: true,
                height: 25,
                colorClass: colorClass,
                progress: data.progress
            });
        } else {
            this.totalProgressBar.updateProgress(data.progress, colorClass);
        }
    },
    updateLastSavedDate: function () {
        let modifiedOn = this.model.get('modifiedOn');
        if (modifiedOn != null) {
            this.$nav.find('.prequal-last-save').text(PJQ.helpers.dateHelpers.getDateString(new Date(modifiedOn), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME));
            this.$nav.find('.prequal-last-save-container').removeClass('hidden');
        }
    },
    renderTokens: function (input) {
        return PJQ.templating.TemplateRenderer.parseMarkup(input, this.options.tokens);
    },
    makeCompletionBadge: function (percent, includeCompleteText) {
        return $('<span class="badge badge-' + this.getCompletionColorClass(percent) + ' prequal-complete-badge wd-45p fs-14 mr-1">' + percent.toString() + (includeCompleteText ? '% Complete' : '%') + '</span>');
    },
    getTabNavElement: function (tabId) {
        return this.$nav.find('[data-nav-tab-id=' + tabId + ']');
    },
    getTabElement: function (tabId) {
        return this.$('[data-tab-id=' + tabId + ']');
    },
    getCategoryElement: function (tabId, categoryId) {
        return this.getTabElement(tabId).find('[data-field-category-id=' + categoryId + ']')
    },
    getFieldElement: function (fieldId) {
        return this.$('[data-field-id=' + fieldId + ']');
    },
    getFieldTab: function (fieldId) {
        let field = _.findWhere(this.model.fields, {
            prequalFieldId: fieldId
        });
        return field ? _.findWhere(this.model.tabs, {
            prequalTabId: field.prequalTabId
        }) : null;
    },
    getCompletionColorClass: function (percent) {
        let textClass = 'danger';
        if (percent === 100)
            textClass = 'success';
        else if (percent > 60)
            textClass = 'warning';

        return textClass;
    },
    renderGroups: function () {
        if (this.$('.prequal-groups').length > 0) {
            let maxGroups = 10;
            if(this.model.preferences.hasPref(PJQ.constants.preferenceTypes.RESTRICT_GROUP_COUNT)){
                let maxGroupsPref = this.model.preferences.getPref(PJQ.constants.preferenceTypes.RESTRICT_GROUP_COUNT);
                if(maxGroupsPref > 0){
                    maxGroups = maxGroupsPref;
                }
            }
            let groupSelector = new PJQ.views.groups.GroupSelector({
                el: this.$('.prequal-groups'),
                isSync: true,
                groupUserId: this.model.get('masterUserId'),
                groupLevels: this.model.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS),
                maxGroups: maxGroups,
                isDisableParents: true,
                selectedGroupIds: this.model.contact.groups.getGroupIds(),
                canEdit: this.options.canEdit,
                isEnableSelectAll: false,
                groupLabel: this.model.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LABEL),
                onGroupSelected: _.bind(function (data) {
                    _.each(data.all, _.bind(function (newGroup) {
                        let existingGroup = this.model.contact.groups.get(newGroup.id),
                            isGroupDeleted = newGroup.get('isDeleted');
                        if (existingGroup) {
                            existingGroup.set('isDeleted', isGroupDeleted);
                        } else if (!existingGroup && !isGroupDeleted) {
                            this.model.contact.groups.add(newGroup);
                        }
                    }, this));

                    let fieldId = this.$('.prequal-groups').data('fieldId');
                    this.queueValidation(this.getFieldTab(fieldId), this.model.fields[fieldId]);
                    this.model.contact.queueSave(null, {
                        success: _.bind(function () {
                            //Remove the deleted groups on successful save so we don't keep sending them
                            // this.model.contact.groups.remove(this.model.contact.groups.where({
                            // 	isDeleted: true
                            // }));
                        }, this)
                    }, 800);
                }, this)
            });
        }
    },
    renderRegions: function () {
        let $regions = this.$('.prequal-regions');
        if (_.size($regions) > 0) {
            this.regionsMap = new PJQ.views.workAreas.WorkAreaMap({
                collection: this.model.contact.workAreas,
                el: $regions,
                contactId: this.model.contact.id,
                isEdit: this.options.canEdit,
                onChange: _.bind(function (obj) {
                    let field = this.model.fields[parseInt(this.$('.prequal-regions').data('fieldId'))];
                    this.queueValidation(this.getFieldTab(field.prequalFieldId), field);
                }, this)
            });
        }
    },
    renderOtherOffices: function (field) {
        _.each(this.model.otherOffices.models, _.bind(function (office) {
            this.renderOtherOffice(field, office);
        }, this));
    },
    renderOtherOffice: function (field, office) {
        let fieldEl = this.getFieldElement(field.prequalFieldId);
        this.renderSubTemplate(true, this.options.subTemplates.otherOffice, fieldEl.find('.grid-items'), {
            field: field,
            item: office,
            isEdit: this.options.canEdit,
            isViewer: false
        }, _.bind(function (content) {
            new PJQ.Binder(content, office, {
                attribute: 'data-c-bind',
                watchElements: [
                    'input'
                ],
                afterChange: _.bind(function (value) {
                    this.prequalChanged(fieldEl, value);
                    office.queueSave({}, {}, 800);
                }, this)
            });

            new PJQ.inputs.Selectpicker({
                el: content.find('.other-office-state'),
                noneSelectedText: 'State',
                defaultValue: office.get('stateProvince'),
                onChange: _.bind(function (value) {
                    this.prequalChanged(fieldEl, value);
                    office.set('stateProvince', value);
                    office.queueSave({}, {}, 800);
                }, this)
            });
        }, this));
    },
    addOtherOffice: function (e) {
        let newOffice = new PJQ.models.prequal.OtherOffice({
            contactId: this.model.contact.id,
            contactCompanyId: this.model.get('contactCompanyId'),
            city: "",
            stateProvince: "",
            postalCode: ""
        });
        this.model.otherOffices.add(newOffice);
        let field = this.model.fields[$(e.currentTarget).data('refFieldId')];
        this.renderOtherOffice(field, newOffice);
        newOffice.save();
        this.queueValidation(this.getFieldTab(field.prequalFieldId), field);
    },
    deleteOtherOffice: function (e) {
        let row = $(e.currentTarget).closest('.grid-item-row'),
            cid = row.data('cid'),
            office = this.model.otherOffices.get(cid);
        office.destroy();
        this.model.otherOffices.remove(office);
        row.remove();
        let field = this.model.fields[$(e.currentTarget).data('refFieldId')],
            tab = this.getFieldTab(field.prequalFieldId);
        this.queueValidation(tab, field);
    },
    renderContactsGrid: function (field, models) {
        _.each(models, _.bind(function (model) {
            this.renderContactsGridItem(field, model);
        }, this));
    },
    renderContactsGridItem: function (field, contact) {
        let fieldEl = this.getFieldElement(field.prequalFieldId);
        this.renderSubTemplate(true, this.options.subTemplates.contact, fieldEl.find('.grid-items'), {
            field: field,
            item: contact,
            isEdit: this.options.canEdit,
        }, _.bind(function (content) {
            new PJQ.Binder(content, contact, {
                attribute: 'data-c-bind',
                watchElements: [
                    'input'
                ],
                afterChange: _.bind(function (value) {
                    this.prequalChanged(fieldEl, value);
                    contact.queueSave({}, {}, 800);
                }, this)
            });

            let acContacts = this.model.getAllPrequalContacts();
            this.renderContactsGridAutocomplete(acContacts, contact);
            PJQ.helpers.inputHelpers.inputMaskPhone(content.find('.input-phone'));
        }, this));
    },
    renderContactsGridsAutocompletes: function () {
        let acContacts = this.model.getAllPrequalContacts();
        _.each(acContacts, function (contact) {
            this.renderContactsGridAutocomplete(acContacts, contact);
        }, this);
    },
    renderContactsGridAutocomplete: function (acContacts, contact) {
        let allContacts = _.filter(acContacts, function (prequalContact) {
                return prequalContact.cid !== contact.cid
            }),
            contactNames = PJQ.helpers.objectHelpers.findDistinct(allContacts, 'contactName');
        if (!this.contactsGridsAutcompletes) {
            this.contactsGridsAutcompletes = [];
        }
        let ac = _.findWhere(this.contactsGridsAutcompletes, {cid: contact.cid}),
            acElement = this.$('.grid-item-row[data-cid=' + contact.cid + ']').find('.contact-name');
        if (acElement.length > 0) {
            if (ac) {
                ac.input.reloadSource({
                    data: contactNames
                });
            } else {
                let acInput = new PJQ.inputs.AutocompleteInput({
                    el: acElement,
                    data: contactNames,
                    dataDisplayProperty: 'contactName',
                    delay: 0,
                    onSelect: _.bind(function (data) {
                        if (data.match) {
                            contact.set({
                                contactName: data.match.get('contactName'),
                                contactTitle: data.match.get('contactTitle'),
                                email: data.match.get('email'),
                                phone: data.match.get('phone')
                            });
                            let row = acInput.$el.closest('.row');
                            row.find('.contact-name').val(contact.get('contactName'));
                            row.find('.contact-title').val(contact.get('contactTitle'));
                            row.find('.contact-email').val(contact.get('email'));
                            row.find('.contact-phone').val(contact.get('phone'));
                            this.prequalChanged(acInput.$el.closest('.prequal-grid'));
                            contact.queueSave({}, {}, 800);
                        }
                    }, this)
                });
                this.contactsGridsAutcompletes.push({
                    cid: contact.cid,
                    input: acInput
                });
            }
        }
    },
    renderOwnerContacts: function (field) {
        this.renderContactsGrid(field, this.model.ownerContacts.models);
    },
    addOwnerContact: function (e) {
        let newContact = new PJQ.models.prequal.OwnerContact({
            contactId: this.model.contact.id,
            contactCompanyId: this.model.get('contactCompanyId'),
            contactName: "",
            contactTitle: "",
            email: "",
            phone: ""
        });
        this.model.ownerContacts.add(newContact);
        let field = this.model.fields[$(e.currentTarget).data('refFieldId')];
        this.renderContactsGridItem(field, newContact);
        newContact.save();
        this.queueValidation(this.getFieldTab(field.prequalFieldId), field);
    },
    deleteOwnerContact: function (e) {
        let row = $(e.currentTarget).closest('.grid-item-row'),
            cid = row.data('cid'),
            contact = this.model.ownerContacts.get(cid);
        contact.destroy();
        this.model.ownerContacts.remove(contact);
        row.remove();
        let field = this.model.fields[$(e.currentTarget).data('refFieldId')],
            tab = this.getFieldTab(field.prequalFieldId);
        this.queueValidation(tab, field);
    },
    renderOperationsContacts: function (field) {
        this.renderContactsGrid(field, this.model.operationsContacts.models);
    },
    addOperationsContact: function (e) {
        let newContact = new PJQ.models.prequal.OperationsContact({
            contactId: this.model.contact.id,
            contactCompanyId: this.model.get('contactCompanyId'),
            contactName: "",
            email: "",
            phone: ""
        });
        this.model.operationsContacts.add(newContact);
        let field = this.model.fields[$(e.currentTarget).data('refFieldId')];
        this.renderContactsGridItem(field, newContact);
        newContact.save();
        this.queueValidation(this.getFieldTab(field.prequalFieldId), field);
    },
    deleteOperationsContact: function (e) {
        let row = $(e.currentTarget).closest('.grid-item-row'),
            cid = row.data('cid'),
            contact = this.model.operationsContacts.get(cid);
        contact.destroy();
        this.model.operationsContacts.remove(contact);
        row.remove();
        let field = this.model.fields[$(e.currentTarget).data('refFieldId')],
            tab = this.getFieldTab(field.prequalFieldId);
        this.queueValidation(tab, field);
    },
    renderEstimatingContacts: function (field) {
        this.renderContactsGrid(field, this.model.estimatingContacts.models);
    },
    addEstimatingContact: function (e) {
        let newContact = new PJQ.models.prequal.EstimatingContact({
            contactId: this.model.contact.id,
            contactCompanyId: this.model.get('contactCompanyId'),
            contactName: "",
            email: "",
            phone: ""
        });
        this.model.estimatingContacts.add(newContact);
        let field = this.model.fields[$(e.currentTarget).data('refFieldId')];
        this.renderContactsGridItem(field, newContact);
        newContact.save();
        this.queueValidation(this.getFieldTab(field.prequalFieldId), field);
    },
    deleteEstimatingContact: function (e) {
        let row = $(e.currentTarget).closest('.grid-item-row'),
            cid = row.data('cid'),
            contact = this.model.estimatingContacts.get(cid);
        contact.destroy();
        this.model.estimatingContacts.remove(contact);
        row.remove();
        let field = this.model.fields[$(e.currentTarget).data('refFieldId')],
            tab = this.getFieldTab(field.prequalFieldId);
        this.queueValidation(tab, field);
    },
    renderSafetyContacts: function (field) {
        this.renderContactsGrid(field, this.model.safetyContacts.models);
    },
    addSafetyContact: function (e) {
        let newContact = new PJQ.models.prequal.SafetyContact({
            contactId: this.model.contact.id,
            contactCompanyId: this.model.get('contactCompanyId'),
            contactName: "",
            email: "",
            phone: ""
        });
        this.model.safetyContacts.add(newContact);
        let field = this.model.fields[$(e.currentTarget).data('refFieldId')];
        this.renderContactsGridItem(field, newContact);
        newContact.save();
        this.queueValidation(this.getFieldTab(field.prequalFieldId), field);
    },
    deleteSafetyContact: function (e) {
        let row = $(e.currentTarget).closest('.grid-item-row'),
            cid = row.data('cid'),
            contact = this.model.safetyContacts.get(cid);
        contact.destroy();
        this.model.safetyContacts.remove(contact);
        row.remove();
        let field = this.model.fields[$(e.currentTarget).data('refFieldId')],
            tab = this.getFieldTab(field.prequalFieldId);
        this.queueValidation(tab, field);
    },
    renderProjectReferences: function (field) {
        _.each(this.model.projectReferences.models, _.bind(function (model) {
            this.renderProjectReference(field, model);
        }, this));
    },
    renderProjectReference: function (field, reference) {
        let fieldEl = this.getFieldElement(field.prequalFieldId);
        this.renderSubTemplate(true, this.options.subTemplates.projectReference, fieldEl.find('.grid-items'), {
            field: field,
            item: reference,
            isEdit: reference.checkIsRecent() && this.options.canEdit,
            isViewer: false
        }, _.bind(function (content) {
            new PJQ.Binder(content, reference, {
                attribute: 'data-c-bind',
                watchElements: [
                    'input'
                ],
                afterChange: _.bind(function (value) {
                    this.prequalChanged(fieldEl);
                    reference.queueSave({}, {}, 800);
                }, this)
            });

            new PJQ.inputs.Datepicker({
                el: content.find('.input-date'),
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.DATE.toUpperCase(),
                    defaultDate: reference.get('dateCompleted')
                },
                onChange: _.bind(function (value) {
                    this.prequalChanged(fieldEl);
                    reference.set('dateCompleted', value);
                    reference.queueSave({}, {}, 800);
                }, this)
            });

            PJQ.helpers.inputHelpers.inputMaskCurrency(content.find('.input-dollars'));
            PJQ.helpers.inputHelpers.inputMaskPhone(content.find('.input-phone'));
        }, this));
    },
    addProjectReference: function (e) {
        let newReference = new PJQ.models.prequal.ProjectReference({
            contactId: this.model.contact.id,
            contactCompanyId: this.model.get('contactCompanyId'),
            generalContractor: "",
            generalContractorContactName: "",
            generalContractorContactPhone: "",
            projectName: "",
            dateCompleted: null,
            contractValue: 0
        });
        this.model.projectReferences.add(newReference);
        let field = this.model.fields[$(e.currentTarget).data('refFieldId')];
        this.renderProjectReference(field, newReference);
        newReference.save();
        this.queueValidation(this.getFieldTab(field.prequalFieldId), field);
    },
    deleteProjectReference: function (e) {
        let row = $(e.currentTarget).closest('.grid-item-row'),
            cid = row.data('cid'),
            reference = this.model.projectReferences.get(cid);
        reference.destroy();
        this.model.projectReferences.remove(reference);
        row.remove();
        let field = this.model.fields[$(e.currentTarget).data('refFieldId')],
            tab = this.getFieldTab(field.prequalFieldId);
        this.queueValidation(tab, field);
    },
    allowZip: function (e) {
        return PJQ.helpers.inputHelpers.allowZip(e);
    },
    numbersOnly: function (e) {
        return PJQ.helpers.inputHelpers.numbersOnly(e, false, true);
    },
    formatPercent: function (e) {
        $(e.currentTarget).val(PJQ.helpers.formatHelpers.formatPercent($(e.currentTarget).val()));
    },
    networkUpgrade: function () {
        let redirectURL = 'http://network.panteratools.com/pantera-network/?';
        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_PROQUAL_PORTAL))
            redirectURL = 'http://demo.panteratools.com/verified-network-long-video-page/?';
        //todo: load directorysettings from api
        else if (directorySettings.IsNetworkContact && directorySettings.NetworkVerificationLevel == 1)
            redirectURL = 'http://demo.panteratools.com/verified-network-landing-pages-from-pn/?';
        window.open(redirectURL + this.model.contact.id.toString(), '_blank');
    },
    editProfile: function () {
        PJQ.app.router.navigate('profile', {
            trigger: true
        });
    },
    viewFaq: function () {
        let faqItems = this.options.baseFaqItems;
        if (!this.model.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DODGE_CRM) && !this.model.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DODGE_WG))
            faqItems = _.union(faqItems, this.options.proqualFaqItems);
        new PJQ.views.BaseModal({
            header: "Frequently Asked Questions",
            isShowOkButton: false,
            isShowCancelButton: true,
            cancelButtonText: "Close",
            body: PJQ.templating.TemplateRenderer.parseTemplate(this.options.subTemplates.faq, {
                faqItems: faqItems
            }).html(),
            okButtonText: "Ok"
        });
    },
    navClicked: function (e) {
        if (this.regionsMap != null && $($(e.target).attr('href')).length > 0)
            this.regionsMap.refresh();

        this.tabChanged();
    },
    lockPrequal: function () {
        if (this.options.isAdmin) {
            this.model.updateLocked(true, _.bind(function () {
                this.render();
                PJQ.notifications.notify.successNotify({
                    message: 'Prequalification Locked'
                });
            }, this));
        }
    },
    unlockPrequal: function () {
        if (this.options.isAdmin) {
            this.model.updateLocked(false, _.bind(function () {
                this.render();
                PJQ.notifications.notify.successNotify({
                    message: 'Prequalification Unlocked'
                });
            }, this));
        }
    },
    previousTab: function () {
        this.changeTab(-1);
    },
    nextTab: function () {
        let currentTabId = parseInt(this.$nav.find('.prequal-nav-item.active').data('navTabId')),
            tabIndex = null;
        _.each(this.model.tabs, function (tab, index) {
            if (tab.prequalTabId === currentTabId)
                tabIndex = index;
        }, this);
        if (this.model.get('isRequireSignature') && tabIndex === this.model.tabs.length - 1) {
            let incompleteTab = _.find(this.model.completionData.tabs, function (tab) {
                return !this.$nav.find('.prequal-nav-item[data-nav-tab-id="' + tab.tab.prequalTabId + '"]').hasClass('hidden') && tab.progress < 100;
            }, this);
            if (incompleteTab == null) {
                this.continue();
            } else {
                this.$nav.find('.prequal-nav-item[data-nav-tab-id="' + incompleteTab.tab.prequalTabId + '"]').tab('show');
                this.tabChanged();
            }
        } else {
            this.changeTab(1);
        }
    },
    changeTab: function (jump) {
        let tabId = parseInt(this.$nav.find('.prequal-nav-item.active').data('navTabId')),
            currentTab = _.findWhere(this.model.tabs, {prequalTabId: tabId}),
            newTab = _.find(_.sortBy(this.model.tabs, function (tab) {
                if (jump < 0) {
                    return -tab.sortOrder;
                }
                return tab.sortOrder;
            }), function (tab) {
                return !this.$nav.find('.prequal-nav-item[data-nav-tab-id="' + tab.prequalTabId + '"]').hasClass('hidden') && ((tab.sortOrder > currentTab.sortOrder && jump > 0) || (tab.sortOrder < currentTab.sortOrder && jump < 0));
            }, this);
        if (newTab != null) {
            this.$nav.find('.prequal-nav-item[data-nav-tab-id="' + newTab.prequalTabId + '"]').tab('show');
            scrollTo(0, 0);
            this.tabChanged();
        }
    },
    tabChanged: function () {
        PJQ.app.scrollTo(0, 0);

        let currentTabId = parseInt(this.$nav.find('.prequal-nav-item.active').data('navTabId')),
            tabIndex = null;
        _.each(this.model.tabs, function (tab, index) {
            if (tab.prequalTabId === currentTabId)
                tabIndex = index;
        }, this);


        if (tabIndex !== this.model.tabs.length - 1) {
            let tab = _.findWhere(this.model.tabs, {
                    prequalTabId: currentTabId
                }),
                nextTab = _.find(this.model.tabs, function (checkTab) {
                    if (checkTab.sortOrder > tab.sortOrder) {
                        return null != _.find(checkTab.fields, function (field) {
                            if (field.isHidden || field.isAdmin && !this.options.isAdmin) {
                                return false;
                            }

                            if (this.options.isAdmin && _.size(field.allowedUserTypeIds) > 0) {
                                return field.allowedUserTypeIds.indexOf(PJQ.app.session.user.get('userTypeId')) !== -1;
                            }

                            return true;
                        }, this);
                    }
                }, this);
            if (nextTab != null) {
                this.$('.prequal-tab-next').removeClass('hidden');
            } else {
                this.$('.prequal-tab-next').addClass('hidden')
            }
        } else
            this.$('.prequal-tab-next').addClass('hidden');
        if (tabIndex > 0)
            this.$('.prequal-tab-previous').removeClass('hidden');
        else
            this.$('.prequal-tab-previous').addClass('hidden');
    },
    downloadFieldFile: function (e) {
        let fieldId = $(e.currentTarget).data('fieldId'),
            field = this.model.fields[fieldId];
        if (_.size(field.defaultValue.trim()) > 0) {
            PJQ.files.downloadFile(field.defaultValue, {
                isEndpoint: false
            });
        } else {
            //todo: show error that the field doesnt have a valid file associated with it
        }
    },
    fillDefaults: function () {
        _.each(_.filter(this.model.fields, _.bind(function (field) {
            return _.size(field.defaultValue) > 0 && ((typeof field.fieldValue === 'string' && _.size(field.fieldValue) === 0) || field.fieldValue == null);
        }, this)), _.bind(function (field) {
            let fieldEl = this.getFieldElement(field.prequalFieldId);
            this.prequalChanged(fieldEl, parseInt(field.defaultValue), field.prequalFieldId, false);
        }, this));
    },
    updateFormulaFields: function () {
        if (PJQ.helpers.objectHelpers.checkNested(PJQ.app, 'portal', 'customization', 'prequal')) {
            let preventInitCalc = PJQ.app.portal.customization.prequal.preventInitCalc;
            preventInitCalc = preventInitCalc ? preventInitCalc : [];
            _.each(this.formulaFields, _.bind(function (linkedIds, sFieldId) {
                if (_.size(linkedIds) === 0) {
                    return;
                }

                let fieldId = parseInt(sFieldId),
                    field = this.model.fields[fieldId];
                if (field != null && fieldId > 0 && preventInitCalc.indexOf(field.prequalFieldId) === -1) {
                    let fieldEl = this.getFieldElement(fieldId);
                    if (_.size(fieldEl) > 0 && (field.fieldValue > 0 || _.size(field.fieldValue) > 0)) {
                        this.prequalChanged(fieldEl, field.fieldValue, fieldId, false);
                    }
                }
            }, this));
        }
    },
    updateCalcFields: function (changedField) {
        _.each(_.filter(this.model.fields, _.bind(function (field) {
            return field.fieldType.toLowerCase() === 'calc';
        }, this)), _.bind(function (calcField) {
            if (changedField != null) {
                this.updateCalcField(calcField, changedField);
            }
        }, this));
    },
    updateCalcField: function (calcField, changedField) {
        if (_.size(calcField.defaultValue) > 0) {
            let equation = calcField.defaultValue,
                calcFieldsVars = equation.match(/\[(.*?)]/g);
            //If this is for a particular changed field, only recalculate if that field is in the equation
            if (changedField != null && calcFieldsVars.indexOf('[' + changedField.prequalFieldId + ']') === -1)
                return;
            _.each(calcFieldsVars, function (calcFieldVarString) {
                let calcFieldVarId = parseInt(calcFieldVarString.replace(new RegExp(/[\[\]']+/g), '')),
                    calcFieldVar = this.model.fields[calcFieldVarId],
                    calcFieldVarValue = 0;
                if (calcFieldVar != null && (calcFieldVar.fieldType.toLowerCase() === 'int' || calcFieldVar.fieldType.toLowerCase() === 'calc') && _.isNumber(calcFieldVar.fieldValue)) {
                    calcFieldVarValue = calcFieldVar.fieldValue;
                }
                equation = equation.replace(calcFieldVarString, '(' + calcFieldVarValue + ')');
            }, this);
            let solution = math.eval(equation);
            calcField.fieldValue = !_.isNumber(solution) || isNaN(solution) ? 0 : solution;
            let customFields = {};
            customFields[calcField.fieldNumber] = calcField.fieldValue;
            this.model.set('customFieldValues', _.defaults(customFields, this.model.dirtyAttributes.customFieldValues));
            this.getFieldElement(calcField.prequalFieldId).val(calcField.fieldValue);
        }
    }
});
//Models
PJQ.models.prequal = {};

PJQ.models.prequal.Form = PJQ.models.BaseModel.extend({
    idAttribute: 'masterUserId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'prequal'
            },
            {
                endpoint: 'form'
            }
        ], [
            {
                parameter: 'masterUserId',
                value: this.get('masterUserId') > 0 ? this.get('masterUserId') : (PJQ.app.session.preferences.hasPref('portalOwner') ? PJQ.app.session.preferences.getPref('portalOwner') : PJQ.app.session.get('masterUserId'))
            }
        ]);
    },
    parse: function (model) {
        if (model && _.size(model) > 0) {
            this.tabs = {};
            this.fields = {};
            this.categories = [];
            if (model.tabs) {
                this.tabs = model.tabs;
                _.each(model.tabs, _.bind(function (tab) {
                    _.each(tab.fields, _.bind(function (field) {
                        this.fields[field.prequalFieldId] = field;
                        if (this.categories.indexOf(field.category) < 0) {
                            this.categories.push(field.category);
                        }
                    }, this));
                }, this));
            }

            if (this.preferences && model.preferences) {
                this.preferences.set(model.preferences);
            } else {
                this.preferences = new PJQ.models.preferences.Preferences(model.preferences);
            }
        }
        return model;
    }
});

PJQ.models.prequal.Prequal = PJQ.models.BaseModel.extend({
    idAttribute: 'prequalCoreId',
    endpoint: function () {
        if (this.id > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'prequal',
                    value: this.id
                },
                {
                    endpoint: 'data'
                }
            ], [
                {
                    parameter: 'masterUserId',
                    value: this.get('masterUserId') > 0 ? this.get('masterUserId') : (PJQ.app.session.preferences.hasPref('portalOwner') ? PJQ.app.session.preferences.getPref('portalOwner') : PJQ.app.session.get('masterUserId'))
                }
            ]);
        } else if (this.contact != null && this.contact.id > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'contacts',
                    value: this.contact.id
                },
                {
                    endpoint: 'prequal'
                },
                {
                    endpoint: 'data'
                }
            ], [
                {
                    parameter: 'masterUserId',
                    value: this.get('masterUserId') > 0 ? this.get('masterUserId') : (PJQ.app.session.preferences.hasPref('portalOwner') ? PJQ.app.session.preferences.getPref('portalOwner') : PJQ.app.session.get('masterUserId'))
                }
            ]);
        }
        return null;
    },
    fetch: function (options) {
        let fnSuccess = options ? options.success : _.noop();
        PJQ.models.BaseModel.prototype.fetch.call(this, _.defaults({
            success: _.bind(function () {
                let cbArgs = arguments;
                PJQ.app.session.fetchPrequalForm(this.get('masterUserId'), _.bind(function (form) {
                    this.parseForm(form);
                    if (typeof fnSuccess === 'function') {
                        fnSuccess(...cbArgs);
                    }
                }, this));
            }, this),
            fail: options ? options.fail : _.noop()
        }, options));
    },
    addPatchValue: function (obj) {
        if (_.size(obj.attribute) === 0) {
            return;
        }

        if (this.dirtyAttributes.patchValues == null) {
            this.dirtyAttributes.patchValues = [];
        } else {
            for (let i = 0; i < _.size(this.dirtyAttributes.patchValues); i++) {
                if (this.dirtyAttributes.patchValues[i].attribute === obj.attribute) {
                    this.dirtyAttributes.patchValues[i].value = obj.value;
                    return;
                }
            }
        }
        this.dirtyAttributes.patchValues.push(obj);

        this.set('patchValues', this.dirtyAttributes.patchValues);
    },
    parseForm: function (form) {
        this.tabs = form.tabs;
        this.fields = form.fields;
        this.categories = form.categories;
        this.preferences = form.preferences;

        _.each(this.fields, function (field) {
            field.fieldValue = null;
            if (_.size(field.coreFieldName) > 0) {
                if (field.coreFieldName.indexOf('Contact.ccf_') !== -1) {
                    if (this.contact != null) {
                        let fieldId = parseInt(field.coreFieldName.replace('Contact.ccf_', ''));
                        _.each(this.contact.get('companyCustomFieldValues'), function (customField) {
                            if (customField.id === fieldId) {
                                field.fieldValue = customField.value;
                            }
                        });
                    }
                } else if (field.coreFieldName.indexOf('Contact.cf_') !== -1) {
                    if (this.contact != null) {
                        let fieldId = parseInt(field.coreFieldName.replace('Contact.cf_', ''));
                        _.each(this.contact.get('contactCustomFieldValues'), function (customField) {
                            if (customField.id === fieldId) {
                                field.fieldValue = customField.value;
                            }
                        });
                    }
                } else if (field.coreFieldName.toLowerCase() === 'isunion|isnonunion') {
                    let tempVal = [];
                    if (this.contact != null) {
                        if (this.contact.get('isUnion')) {
                            tempVal.push('Union');
                        }
                        if (this.contact.get('isNonUnion')) {
                            tempVal.push('Non-Union');
                        }
                    }
                    field.fieldValue = tempVal;
                } else if (field.coreFieldName.indexOf('Contact.') > -1) {
                    field.fieldValue = this.contact.get(PJQ.helpers.formatHelpers.lowerCaseFirstLetter(field.coreFieldName.replace('Contact.', '')));
                } else {
                    field.fieldValue = this.get(PJQ.helpers.formatHelpers.lowerCaseFirstLetter(field.coreFieldName));
                }
            } else if (field.fieldNumber > 0) {
                let tempVal = this.get('customFieldValues')[field.fieldNumber];
                if (typeof tempVal === 'string') {
                    switch (field.fieldType.toLowerCase()) {
                        case 'bool':
                            if (tempVal.toLowerCase() === 'true') {
                                tempVal = true;
                            } else if (tempVal.toLowerCase() === 'false') {
                                tempVal = false;
                            } else {
                                tempVal = null;
                            }
                            break;
                        case 'int':
                            let tryParse = parseInt(tempVal);
                            if (!isNaN(tryParse)) {
                                tempVal = tryParse;
                            }
                            break;
                        case 'choice':
                            if (tempVal.indexOf('|') !== -1) {
                                let choiceIds = [];
                                _.each(tempVal.split('|'), function (choiceVal) {
                                    let tryParse = parseInt(choiceVal);
                                    if (!isNaN(tryParse)) {
                                        choiceIds.push(tryParse);
                                    }
                                })
                                tempVal = choiceIds;
                            } else {
                                let tryParse = parseInt(tempVal);
                                if (!isNaN(tryParse)) {
                                    tempVal = tryParse;
                                } else {
                                    tempVal = null;
                                }
                            }
                            break;
                    }
                }
                field.fieldValue = tempVal;
            }
        }, this);
    },
    parse: function (model) {
        if (model && _.size(model) > 0) {
            if (this.contact && model.contact != null) {
                this.contact.set(model.contact);
                this.contact.parse(model.contact);
            } else {
                if (model.contact) {
                    if (model.contact instanceof PJQ.models.contacts.Contact)
                        this.contact = model.contact;
                    else
                        this.contact = new PJQ.models.contacts.Contact(model.contact);
                } else {
                    this.contact = new PJQ.models.contacts.Contact();
                }
            }

            this.comments = new PJQ.collections.prequal.Comments(model.comments);

            if (this.estimatingContacts) {
                this.estimatingContacts.reset(model.estimatingContacts);
            } else {
                this.estimatingContacts = new PJQ.collections.prequal.EstimatingContacts(model.estimatingContacts);
            }
            _.each(this.estimatingContacts.models, function (mod) {
                mod.set('contactId', this.contact.id);
            }, this);

            if (this.operationsContacts) {
                this.operationsContacts.reset(model.operationsContacts);
            } else {
                this.operationsContacts = new PJQ.collections.prequal.OperationsContacts(model.operationsContacts);
            }
            _.each(this.operationsContacts.models, function (mod) {
                mod.set('contactId', this.contact.id);
            }, this);

            if (this.ownerContacts) {
                this.ownerContacts.reset(model.ownerContacts);
            } else {
                this.ownerContacts = new PJQ.collections.prequal.OwnerContacts(model.ownerContacts);
            }
            _.each(this.ownerContacts.models, function (mod) {
                mod.set('contactId', this.contact.id);
            }, this);

            if (this.safetyContacts) {
                this.safetyContacts.reset(model.safetyContacts);
            } else {
                this.safetyContacts = new PJQ.collections.prequal.SafetyContacts(model.safetyContacts);
            }
            _.each(this.safetyContacts.models, function (mod) {
                mod.set('contactId', this.contact.id);
            }, this);

            if (this.otherOffices) {
                this.otherOffices.reset(model.otherOffices);
            } else {
                this.otherOffices = new PJQ.collections.prequal.OtherOffices(model.otherOffices);
            }
            _.each(this.otherOffices.models, function (mod) {
                mod.set('contactId', this.contact.id);
            }, this);

            if (this.projectReferences) {
                this.projectReferences.reset(model.projectReferences);
            } else {
                this.projectReferences = new PJQ.collections.prequal.ProjectReferences(model.projectReferences);
            }
            _.each(this.projectReferences.models, function (mod) {
                mod.set('contactId', this.contact.id);
            }, this);
        }
        return model;
    },
    sign: function (signature, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'prequal',
                    value: this.id
                },
                {
                    endpoint: 'sign'
                }
            ], [
                {
                    parameter: 'masterUserId',
                    value: this.get('masterUserId')
                }
            ]),
            data: {
                signature: signature
            }
        }).put().done(_.bind(function (res) {
            if (res.isLocked) {
                this.set('isLocked', res.isLocked);
            }
            this.set('signedOn', new Date(), {silent: true});
            callback(true);
        }, this));
    },
    updateLocked: function (isLocked, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'prequal',
                    value: this.id
                },
                {
                    endpoint: 'lock'
                }
            ], [
                {
                    parameter: 'isLocked',
                    value: isLocked
                }
            ])
        }).put().done(_.bind(function () {
            this.set('isLocked', isLocked);
            callback(true);
        }, this));
    },
    updateCompletion: function () {
        if (this.id > 0) {
            this.calculateCompletion();
            this.patch({
                percentComplete: this.get('percentComplete'),
                masterUserId: this.get('masterUserId')
            });
        }
    },
    calculateCompletion: function (isAdmin = false) {
        if (this.completionData == null) {
            this.completionData = {
                tabs: {},
                progress: 0
            };
        }
        _.each(this.tabs, _.bind(function (tabObj) {
            if (this.completionData.tabs[tabObj.prequalTabId] == null) {
                this.completionData.tabs[tabObj.prequalTabId] = {
                    fields: {},
                    tab: tabObj,
                    progress: 0,
                    isCalculate: tabObj.isCalculate
                }
            }
            let completionTab = this.completionData.tabs[tabObj.prequalTabId];
            _.each(tabObj.fields, (field) => {
                if (!field.isHidden && field.isRequired) {
                    if (!this.checkConstraintsMet(field)) {
                        completionTab.fields = _.omit(completionTab.fields, function (omitField) {
                            return omitField.field.prequalFieldId === field.prequalFieldId;
                        });
                    } else {
                        completionTab.fields[field.prequalFieldId] = {
                            field: field,
                            isValid: this.validateField(tabObj, field),
                            isAdmin: field.isAdmin
                        };
                    }
                }
            });

            let fieldCount = _.size(completionTab.fields),
                externalFieldCount = _.size(_.where(completionTab.fields, {
                    isAdmin: false
                }));
            if (fieldCount === 0) {
                completionTab.progress = 100;
                completionTab.saveProgress = 100;
            } else {
                if (externalFieldCount === 0) {
                    completionTab.saveProgress = 100;
                } else {
                    completionTab.saveProgress = Math.floor((_.size(_.where(completionTab.fields, {
                        isValid: true,
                        isAdmin: false
                    })) / externalFieldCount) * 100);
                }

                if (isAdmin) {
                    completionTab.progress = Math.floor((_.size(_.where(completionTab.fields, {
                        isValid: true
                    })) / fieldCount) * 100);
                } else {
                    completionTab.progress = completionTab.saveProgress;
                }
            }
        }, this));

        let fullTotal = 0,
            saveTotal = 0,
            calcTabCount = 0;
        _.each(this.completionData.tabs, function (tab) {
            if (tab.isCalculate !== false) {
                saveTotal += tab.saveProgress;
                calcTabCount++;
            }
            fullTotal += this.options.isAdmin ? tab.progress : tab.saveProgress;
        }, this);
        this.completionData.saveProgress = Math.floor(saveTotal / calcTabCount);
        this.completionData.progress = Math.floor(fullTotal / _.size(this.completionData.tabs));

        let completion = {
            percentComplete: this.completionData.saveProgress,
            totalComplete: this.completionData.progress,
            completionData: this.getCompletionData()
        };
        this.set(completion);
        return completion;
    },
    getCompletionData: function () {
        return {
            tabs: _.map(this.completionData.tabs, (calc) => {
                return {
                    id: calc.tab.prequalTabId,
                    progress: calc.progress
                };
            })
        };
    },
    checkConstraintsMet: function (field) {
        let isConstraintsMet = true;
        _.each(_.where(field.constraints, {customFieldId: field.prequalFieldId}), _.bind(function (constraint) {
            let controllerField = this.fields[constraint.controlledByCustomFieldId];
            if (controllerField == null)
                return;
            // else if (!this.checkConstraintsMet(controllerField)) {
            //     isConstraintsMet = false;
            //     return;
            // }
            switch (controllerField.fieldType.toLowerCase()) {
                case 'int':
                case 'money':
                case 'percent':
                    if (parseInt(constraint.constraintInfo) !== controllerField.fieldValue)
                        isConstraintsMet = false;
                    break;
                case 'text':
                case 'textarea':
                case 'phone':
                case 'date':
                    if (constraint.constraintInfo !== controllerField.fieldValue)
                        isConstraintsMet = false;
                    break;
                case 'choice':
                    let type = PJQ.helpers.objectHelpers.refinedType(controllerField.fieldValue);
                    if (_.find(constraint.constraintInfo.split('|'), function (choiceId) {
                        return controllerField.fieldValue != null && ((type === 'number' && controllerField.fieldValue === parseInt(choiceId)) || (type === 'array' && (controllerField.fieldValue.indexOf(parseInt(choiceId)) > -1 || controllerField.fieldValue.indexOf(choiceId) > -1)) || (type === 'object' && controllerField.fieldValue[parseInt(choiceId)] != null));
                    }) == null)
                        isConstraintsMet = false;
                    break;
                case 'bool':
                    if (constraint.constraintInfo != null) {
                        let cLower = constraint.constraintInfo.toString().toLowerCase();
                        if (cLower === '!true') {
                            if (controllerField.fieldValue === true) {
                                isConstraintsMet = false;
                            }
                        } else if (((constraint.constraintInfo === 'true' || constraint.constraintInfo === true) !== controllerField.fieldValue))
                            isConstraintsMet = false;
                    }

                    break;
            }
        }, this));
        return isConstraintsMet;
    },
    validateField: function (tab, field) {
        if (!field.isRequired)
            return true;

        let isValid = false;
        switch (field.fieldType.toLowerCase()) {
            case 'upload':
                isValid = field.fieldValue != null && _.size(field.fieldValue) > 0;
                break;
            case 'int':
            case 'money':
            case 'percent':
                isValid = field.fieldValue != null && !isNaN(parseFloat(field.fieldValue));
                break;
            case 'choice':
                isValid = field.fieldValue != null && ((!isNaN(field.fieldValue) && field.fieldValue > 0) || _.size(field.fieldValue) > 0);
                break;
            case 'text':
            case 'textarea':
            case 'phone':
            case 'date':
            case 'state':
                isValid = field.fieldValue != null && field.fieldValue.length > 0;
                break;
            case 'bool':
                isValid = (field.fieldValue === true || field.fieldValue === false);
                break;
            case 'grid':
                if (field.coreFieldName.toLowerCase() === 'otheroffices') {
                    isValid = _.size(_.filter(this.otherOffices ? this.otherOffices.models : [], _.bind(function (office) {
                        let isCityValid = office.get('city').length > 0,
                            isStateValid = office.get('stateProvince').length > 0,
                            isZipValid = office.get('postalCode').length > 0;
                        return isCityValid && isStateValid && isZipValid;
                    }, this))) >= 1;
                } else if (field.coreFieldName.toLowerCase() === 'ownercontacts' || field.coreFieldName.toLowerCase() === 'operationscontacts' || field.coreFieldName.toLowerCase() === 'estimatingcontacts' || field.coreFieldName.toLowerCase() === 'safetycontacts') {
                    let contacts;
                    if (field.coreFieldName.toLowerCase() === 'ownercontacts') {
                        contacts = this.ownerContacts;
                    } else if (field.coreFieldName.toLowerCase() === 'operationscontacts') {
                        contacts = this.operationsContacts;
                    } else if (field.coreFieldName.toLowerCase() === 'estimatingcontacts') {
                        contacts = this.estimatingContacts;
                    } else if (field.coreFieldName.toLowerCase() === 'safetycontacts') {
                        contacts = this.safetyContacts;
                    }
                    isValid = _.size(_.filter(contacts ? contacts.models : [], _.bind(function (contact) {
                        let isContactNameValid = contact.get('contactName').length > 0,
                            isEmailValid = contact.get('email').length > 0,
                            isPhoneValid = contact.get('phone').length > 0;
                        if (field.coreFieldName.toLowerCase() === 'ownercontacts') {
                            let isTitleValid = contact.get('contactTitle').length > 0;
                            return isContactNameValid && isEmailValid && isPhoneValid && isTitleValid;
                        } else {
                            return isContactNameValid && isEmailValid && isPhoneValid;
                        }
                    }, this))) >= 1;
                } else if (field.coreFieldName.toLowerCase() === 'projectreferences') {
                    isValid = _.size(_.filter(this.projectReferences ? this.projectReferences.models : [], function (reference) {
                        return reference.checkIsRecent();
                    })) >= 3;

                    isValid = _.size(_.filter(this.projectReferences.models ? this.projectReferences.models : [], _.bind(function (reference) {
                        if (!reference.checkIsRecent())
                            return false;

                        let isGCValid = reference.get('generalContractor').length > 0,
                            isGCContactValid = reference.get('generalContractorContactName').length > 0,
                            isGCPhoneValid = reference.get('generalContractorContactPhone').length > 0,
                            isProjectNameValid = reference.get('projectName').length > 0,
                            isDateCompletedValid = reference.get('dateCompleted') !== null,
                            isContractValueValid = reference.get('contractValue') > 0;
                        return isGCValid && isGCContactValid && isGCPhoneValid && isProjectNameValid && isDateCompletedValid && isContractValueValid;
                    }, this))) >= 3;
                }
                break;
            case 'groupselect':
                isValid = _.find(this.contact.groups.models, function (model) {
                    return model.get('isDeleted') !== true
                }) != null;
                break;
            case 'regionselect':
                isValid = this.contact.workAreas != null && _.size(this.contact.workAreas.models) > 0;
                break;
        }
        return isValid;
    },
    getAllPrequalContacts: function () {
        return _.union(this.operationsContacts.models, this.estimatingContacts.models, this.safetyContacts.models)
    }
});

PJQ.models.prequal.OtherOffice = PJQ.models.BaseModel.extend({
    idAttribute: "officeId",
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts',
                value: this.get('contactId') != null ? this.get('contactId') : this.get('contactCompanyId')
            },
            {
                endpoint: 'offices',
                value: this.id
            }
        ]);
    }
});

PJQ.models.prequal.OwnerContact = PJQ.models.BaseModel.extend({
    idAttribute: "ownerContactId",
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts',
                value: this.get('contactId') != null ? this.get('contactId') : this.get('contactCompanyId')
            },
            {
                endpoint: 'ownercontacts',
                value: this.id
            }
        ]);
    }
});

PJQ.models.prequal.OperationsContact = PJQ.models.BaseModel.extend({
    idAttribute: "operationsContactId",
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts',
                value: this.get('contactId') != null ? this.get('contactId') : this.get('contactCompanyId')
            },
            {
                endpoint: 'operationscontacts',
                value: this.id
            }
        ]);
    }
});

PJQ.models.prequal.EstimatingContact = PJQ.models.BaseModel.extend({
    idAttribute: "estimatingContactId",
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts',
                value: this.get('contactId') != null ? this.get('contactId') : this.get('contactCompanyId')
            },
            {
                endpoint: 'estimatingcontacts',
                value: this.id
            }
        ]);
    }
});

PJQ.models.prequal.SafetyContact = PJQ.models.BaseModel.extend({
    idAttribute: "safetyContactId",
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts',
                value: this.get('contactId') != null ? this.get('contactId') : this.get('contactCompanyId')
            },
            {
                endpoint: 'safetycontacts',
                value: this.id
            }
        ]);
    }
});

PJQ.models.prequal.ProjectReference = PJQ.models.BaseModel.extend({
    idAttribute: "projectReferenceId",
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts',
                value: this.get('contactId') != null ? this.get('contactId') : this.get('contactCompanyId')
            },
            {
                endpoint: 'projectreferences',
                value: this.id
            }
        ]);
    },
    parse: function (model) {
        model = model ? model : {};

        model.theme = _.defaults(model && model.theme ? model.theme : {}, this.defaultTheme);

        if (this.photos) {
            this.photos.reset(model.photos);
        } else {
            this.photos = new PJQ.collections.prequal.ProjectReferencePhotos(model.photos);
        }

        return model;
    },
    checkIsRecent: function () {
        let createdOn = this.get('createdOn');
        return PJQ.helpers.dateHelpers.getDateMillisecondsDiff(new Date(), createdOn ? new Date(createdOn) : new Date()) < PJQ.constants.time.millis.ONE_YEAR
    }
});

PJQ.models.prequal.ProjectReferencePhoto = PJQ.models.BaseModel.extend({
    idAttribute: 'projectReferencePhotoId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projectreferences',
                value: this.get('projectReferenceId')
            },
            {
                endpoint: 'photos',
                value: this.id
            }
        ]);
    }
});

PJQ.models.prequal.Comment = PJQ.models.BaseModel.extend({
    idAttribute: "commentId",
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'companies',
                value: this.get('contactCompanyId')
            },
            {
                endpoint: 'prequal'
            },
            {
                endpoint: 'comments',
                value: this.id
            }
        ], [
            {
                parameter: 'masterUserId',
                value: this.get('masterUserId')
            }
        ])
    },
    parse: function (model) {
        if (!model) {
            return model;
        }

        if (model.createdBy != null) {
            this.createdBy = new PJQ.models.projectContacts.ProjectContact(model.createdBy);
        }

        return model;
    }
});

PJQ.models.prequal.AuditLog = PJQ.models.BaseModel.extend({
    idAttribute: 'prequalAuditLogId',
    getValue: function (fieldValue, fieldType) {
        switch (fieldType.toLowerCase()) {
            case 'bool':
                switch (fieldValue) {
                    case '':
                        return '';
                    case '0':
                    case 'false':
                        return 'No';
                    case '1':
                    case 'true':
                        return 'Yes';
                }
                break;
            case 'money':
                if (fieldValue != null)
                    return PJQ.helpers.formatHelpers.formatCurrency(fieldValue);
                break;
            case 'percent':
                if (fieldValue != null)
                    return PJQ.helpers.formatHelpers.formatPercent(fieldValue);
                break;
        }

        return fieldValue;
    }
});

//Collections
PJQ.collections.prequal = {};

PJQ.collections.prequal.OtherOffices = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.prequal.OtherOffice
});

PJQ.collections.prequal.OwnerContacts = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.prequal.OwnerContact
});

PJQ.collections.prequal.OperationsContacts = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.prequal.OperationsContact
});

PJQ.collections.prequal.EstimatingContacts = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.prequal.EstimatingContact
});

PJQ.collections.prequal.SafetyContacts = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.prequal.SafetyContact
});

PJQ.collections.prequal.EstimatingContacts = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.prequal.EstimatingContact
});

PJQ.collections.prequal.ProjectReferences = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.prequal.ProjectReference
});

PJQ.collections.prequal.ProjectReferencePhotos = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.prequal.ProjectReferencePhoto,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projectreferences',
                value: this.id
            },
            {
                endpoint: 'photos'
            }
        ]);
    }
});

PJQ.collections.prequal.Comments = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.prequal.Comment
});

PJQ.collections.prequal.PrequalAuditLog = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.prequal.AuditLog,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'contacts',
                    value: this.options.contactId
                },
                {
                    endpoint: 'prequal'
                },
                {
                    endpoint: 'auditlog'
                }
            ]
        );
    }
});
//Views
PJQ.views.prequal.PrequalViewer = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Form-Viewer'),
		subTemplates: {
			tab: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Form-Viewer-Tab'),
			fieldCategory: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Form-Field-Viewer-Category'),
			field: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Form-Viewer-Field'),
			otherOffice: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Form-Other-Office'),
			contact: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Form-Contact'),
			projectReference: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Form-Project-Reference')
		},
		tokens: {
			currentYear: PJQ.helpers.dateHelpers.getCurrentYear()
		},
		ignoreFieldTypes: [
			'groupselect',
			'regionselect',
			'download'
		]
	},
	events: {
		'click .prequal-export-pdf': 'exportPDF',
		'click .prequal-export-excel': 'exportExcel',
		'click .prequal-request-update': 'requestUpdate'
	},
	beforeFirstRender: function () {
		this.listenTo(this.model, "fetch", this.render);
	},
	beforeRender: function () {
		this.renderData = {
			model: this.model,
			renderTokens: _.bind(this.renderTokens, this)
		};
	},
	afterRender: function () {
		if (this.model.get('modifiedOn') != null) {
			this.renderForm();
		}
	},
	renderForm: function () {
		_.each(_.sortBy(_.filter(this.model.tabs, function (tab) {
			return _.size(tab.fields) > 0 && !tab.isHidden && _.find(tab.fields, function (field) {
				return this.options.ignoreFieldTypes.indexOf(field.fieldType.toLowerCase()) === -1
			}, this) != null
		}, this), function (tab) {
			return tab.sortOrder
		}), function (tab, index) {
			this.renderSubTemplate(true, this.options.subTemplates.tab, this.$('.prequal-tabs'), {
				index: index,
				tab: tab
			});
			let tabEl = this.getTabElement(tab.prequalTabId);

			//Render all of the fields for this tab
			_.each(_.sortBy(_.where(tab.fields, {isHidden: false}), function (field) {
				return field.sortOrder
			}), function (field) {
				let fieldDest = tabEl;
				if (field.category.length > 0) {
					let categoryId = this.model.categories.indexOf(field.category);
					if (categoryId < 0) {
						this.model.categories.push(field.category);
						categoryId = this.model.categories.indexOf(field.category);
					}
					if (this.getCategoryElement(tab.prequalTabId, categoryId).length === 0) {
						this.renderSubTemplate(true, this.options.subTemplates.fieldCategory, fieldDest, {
							category: this.renderTokens(field.category),
							categoryId: categoryId
						});
					}
					fieldDest = this.getCategoryElement(tab.prequalTabId, categoryId);
				}

				let self = this;
				this.renderSubTemplate(true, this.options.subTemplates.field, fieldDest, {
					field: field,
					renderTokens: _.bind(this.renderTokens, this),
					isEdit: true
				}, function ($input) {
					if (field.coreFieldName.toLowerCase() === 'otheroffices')
						self.renderOtherOffices(field);
					else if (field.coreFieldName.toLowerCase() === 'ownercontacts')
						self.renderOwnerContacts(field);
					else if (field.coreFieldName.toLowerCase() === 'operationscontacts')
						self.renderOperationsContacts(field);
					else if (field.coreFieldName.toLowerCase() === 'estimatingcontacts')
						self.renderEstimatingContacts(field);
					else if (field.coreFieldName.toLowerCase() === 'safetycontacts')
						self.renderSafetyContacts(field);
					else if (field.coreFieldName.toLowerCase() === 'projectreferences')
						self.renderProjectReferences(field);
					else if (field.fieldType.toLowerCase() === 'upload') {
						let fnInput = function (attachments) {
							new PJQ.views.files.FileUploaderGrid({
								el: $input.find('.file-uploader'),
								canUpload: false,
								canDelete: false,
								collection: attachments
							});
						};
						if (_.size(field.fieldValue) > 0) {
							new PJQ.ajax.Request({
								endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
									{
										endpoint: 'files'
									},
									{
										endpoint: 'details'
									}
								]),
								data: {
									guids: field.fieldValue.split('|')
								}
							}).post().done(function (result) {
								let attachments = new PJQ.collections.files.Files(result);
								fnInput(attachments);
							});
						}
						else {
							fnInput(new PJQ.collections.files.Files());
						}
					}
				});
			}, this);
		}, this);

		//remove the form-group class from the last item in each category
		//this just makes categories look better
		this.$('[data-field-category-id]').find('.prequal-field-container:last-child').find('.form-group').removeClass('form-group');

		_.each(this.model.fields, function (field) {
			this.renderFieldConstraints(field);
		}, this);

		//Loop through each tab and find non-hidden fields and add a background to the odd rows - ignoring fields in categories
		this.$('[data-tab-id]').each(function () {
			$(this).find('.prequal-field-container:not(.hidden):not(.prequal-constraint)').each(function (index) {
				if ($(this).closest('[data-field-category-id]').length === 0 && index % 2 > 0) {
					$(this).addClass('bg-muted');
				}
			});
		});

		//Loop through each category and find non-hidden fields and add a background to the odd rows
		this.$('[data-field-category-id]').each(function () {
			$(this).find('.prequal-field-container:not(.hidden)').each(function (index) {
				if (index % 2 > 0) {
					$(this).addClass('bg-muted');
				}
			});
		});

		//Update the prequal form percent complete on first load - we want to be sure this is up to date in the database as much as possible
		this.model.updateCompletion();

		this.renderCompletion();
	},
	getTabElement: function (tabId) {
		return this.$('[data-tab-id=' + tabId + ']');
	},
	getCategoryElement: function (tabId, categoryId) {
		return this.getTabElement(tabId).find('[data-field-category-id=' + categoryId + ']')
	},
	getFieldElement: function (fieldId) {
		return this.$('[data-field-id=' + fieldId + ']');
	},
	renderTokens: function (input) {
		return PJQ.templating.TemplateRenderer.parseMarkup(input, this.options.tokens);
	},
	renderFieldConstraints: function (field) {
		if (!field.constraints || field.constraints.length === 0)
			return;

		let controllerField = this.getFieldElement(field.prequalFieldId);
		//Loop through all of the fields which are controlled by this field
		_.each(_.where(field.constraints, {controlledByCustomFieldId: field.prequalFieldId}), _.bind(function (control) {
			//We cant loop through the constraints on the controller custom field because the custom field being controlled may have other constraints
			//So instead we check all of the fields which this constraint field relies on
			let controlField = this.model.fields[control.customFieldId],
				fieldContainer = this.getFieldElement(controlField.prequalFieldId).closest('.prequal-field-container');
			if (controllerField.hasClass('bg-muted'))
				fieldContainer.addClass('bg-muted');
			if (this.model.checkConstraintsMet(controlField)) {
				fieldContainer.removeClass('hidden');
			}
			else {
				fieldContainer.addClass('hidden');
			}
		}, this));
	},
	renderOtherOffices: function (field) {
		_.each(this.model.otherOffices.models, _.bind(function (office) {
			this.renderOtherOffice(field, office);
		}, this));
	},
	renderOtherOffice: function (field, office) {
		let fieldEl = this.getFieldElement(field.prequalFieldId);
		this.renderSubTemplate(true, this.options.subTemplates.otherOffice, fieldEl.find('.grid-items'), {
			field: field,
			item: office,
			isEdit: false,
			isViewer: true
		});
	},
	renderOwnerContacts: function (field) {
		this.renderContactsGrid(field, this.model.ownerContacts.models);
	},
	renderOperationsContacts: function (field) {
		this.renderContactsGrid(field, this.model.operationsContacts.models);
	},
	renderEstimatingContacts: function (field) {
		this.renderContactsGrid(field, this.model.estimatingContacts.models);
	},
	renderSafetyContacts: function (field) {
		this.renderContactsGrid(field, this.model.safetyContacts.models);
	},
	renderContactsGrid: function (field, models) {
		_.each(models, _.bind(function (model) {
			this.renderContactsGridItem(field, model);
		}, this));
	},
	renderContactsGridItem: function (field, contact) {
		let fieldEl = this.getFieldElement(field.prequalFieldId);
		this.renderSubTemplate(true, this.options.subTemplates.contact, fieldEl.find('.grid-items'), {
			field: field,
			item: contact,
			isEdit: false
		}, function (content) {
			PJQ.helpers.inputHelpers.inputMaskPhone(content.find('.input-phone'));
		});
	},
	renderProjectReferences: function (field) {
		_.each(this.model.projectReferences.models, _.bind(function (model) {
			this.renderProjectReference(field, model);
		}, this));
	},
	renderProjectReference: function (field, reference) {
		let fieldEl = this.getFieldElement(field.prequalFieldId);
		this.renderSubTemplate(true, this.options.subTemplates.projectReference, fieldEl.find('.grid-items'), {
			field: field,
			item: reference,
			isEdit: false,
			isViewer: true
		}, function (content) {
			new PJQ.inputs.Datepicker({
				el: content.find('.input-date'),
				datepickerOptions: {
					format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
					defaultDate: reference.get('dateCompleted')
				}
			});

			PJQ.helpers.inputHelpers.inputMaskCurrency(content.find('.input-dollars'));
			PJQ.helpers.inputHelpers.inputMaskPhone(content.find('.input-phone'));
		});
	},
	getCompletionColorClass: function (percent) {
		let textClass = 'danger';
		if (percent === 100)
			textClass = 'success';
		else if (percent > 60)
			textClass = 'warning';

		return textClass;
	},
	renderCompletion: function () {
		let progress = this.model.get('totalComplete'),
			colorClass = this.getCompletionColorClass(progress);
		if (this.totalProgressBar == null) {
			this.totalProgressBar = new PJQ.progress.ProgressBar(this.$('.prequal-progress'), {
				isShowPercentage: true,
				height: 40,
				colorClass: colorClass,
				progress: progress
			});
		}
		else {
			this.totalProgressBar.updateProgress(progress, colorClass);
		}
	},
	exportPDF: function () {
		this.export(false);
	},
	exportExcel: function () {
		this.export(true);
	},
	export: function (isExcel) {
		PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'contacts',
				value: this.model.contact.id
			},
			{
				endpoint: 'prequal'
			},
			{
				endpoint: 'export'
			}
		], [
			{
				parameter: 'masterUserId',
				value: this.model.get('masterUserId') > 0 ? this.model.get('masterUserId') : (PJQ.app.session.preferences.hasPref('portalOwner') ? PJQ.app.session.preferences.getPref('portalOwner') : PJQ.app.session.get('masterUserId'))
			},
			{
				parameter: 'isExcel',
				value: isExcel
			}
		]));
	},
	requestUpdate: function () {
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'contacts',
					value: this.model.contact.id
				},
				{
					endpoint: 'prequal'
				},
				{
					endpoint: 'request'
				}
			])
		}).post().done(_.bind(function (data) {
			if (data) {
				PJQ.notifications.notify.successNotify({
					message: 'Qualification update sent'
				});
				this.$('.prequal-request-update').html('<i class="fal fa-check mr-1"></i>Update Sent').prop('disabled', true);
			}
			else {
				PJQ.notifications.notify.errorNotify({
					message: 'Qualification update failed, invalid email address on contact'
				});
			}
		}, this)).fail(function (xhr, err, result) {
			new PJQ.logging.Debug(PJQ.logging.LoggingActions.SEND_PREQUAL_UPDATE, {
				error: err,
				result: result
			});
		});
	}
});

PJQ.views.prequal.PrequalViewerModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-Viewer-Modal'),
		maxWidth: "1000px",
		width: "95%",
		masterUserId: null
	},
	beforeRender: function () {
		this.renderData = {
			model: this.model
		};
	},
	afterRender: function () {
		if (this.model != null) {
			this.model.fetch({
				success: _.bind(function () {
					let prequal = new PJQ.models.prequal.Prequal({
						contact: this.model,
						masterUserId: this.options.masterUserId
					});
					prequal.fetch({
						success: _.bind(function () {
							new PJQ.views.prequal.PrequalViewer({
								el: this.$('.prequal-container'),
								model: prequal
							});
						}, this)
					});
				}, this)
			});
		}
	}
});

PJQ.views.prequal.PrequalAuditLogModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'modal-prequal-auditlog'),
		minWidth: '1100',
		contactId: null
	},
	events: {},
	beforeModalCreated: function () {
		this.isFetched = false;

		this.data = new PJQ.collections.prequal.PrequalAuditLog(null, {
			contactId: this.options.contactId
		});
		this.data.fetch({
			success: _.bind(function(data) {
				this.isFetched = true;
				this.render();
			}, this)
		});
	},
	afterRender: function () {
		let loader = new PJQ.Loader(this.$('.auditlog-data'));
		if (!this.isFetched)
			return;
		else
			loader.remove();

		this.renderAuditLog()
	},
	renderAuditLog: function () {
		new PJQ.views.dataTables.DataTable({
			el: this.$('.auditlog-data'),
			pageLength: 25,
			isHideSearch: true,
			data: this.data.models,
			columns: [
				{
					"data": {
						"_": function (row) {
							return new Date(row.attributes.createdOn);
						},
						"filter": "attributes.createdOn",
						"display": function (row) {
							return PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.createdOn), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
						}
					},
					"title": "Date",
					"width": "80px",
					"orderable": false
				},
				{
					"data": {
						"_": function (row) {
							return row.attributes.createdBy.companyName + ' - ' + row.attributes.createdBy.contactName;
						},
						"display": function (row) {
							return '<span class="font-weight-light">'+row.attributes.createdBy.companyName + '</span>' + '<br />' + row.attributes.createdBy.contactName;
						}
					},
					"title": "Person",
					"width": "150px",
					"orderable": false
				},
				{
					"data": {
						"_": function (row) {
							return row.attributes.tabName + ' - ' + row.attributes.fieldName;
						},
						"display": function (row) {
							let html = '<span class="font-weight-light">'+row.attributes.tabName + '</span><br />';
							return  html + (row.attributes.category ? + row.attributes.category + '<br />' : '') + row.attributes.fieldName;
						}
					},
					"title": "Field",
					"width": "150px",
					"orderable": false
				},
				{
					"data": {
						"_": function (row) {
							return row.getValue(row.attributes.oldValue, row.attributes.fieldType);
						},
						"display": function (row) {
							return row.getValue(row.attributes.oldValue, row.attributes.fieldType);
						}
					},
					"title": "Original Value",
					"width": "30%",
					"orderable": false
				},
				{
					"data": {
						"_": function (row) {
							return row.getValue(row.attributes.newValue, row.attributes.fieldType);
						},
						"display": function (row) {
							return row.getValue(row.attributes.newValue, row.attributes.fieldType);
						}
					},
					"title": "New Value",
					"width": "30%",
					"orderable": false
				},

			]
		});
	}
});
//Models
PJQ.models.profile = {};

PJQ.models.profile.CompanyProfile = PJQ.models.BaseModel.extend({
	idAttribute: 'profileKey',
	defaults: {
		isFileAPI: true
	},
	defaultTheme: {
		headerBackgroundColor: '#495057',
		navMenuTextColor: '#0071E6',
		sectionHeaderTextColor: '#495057',
		sectionBodyTextColor: '#6c757d'
	},
	endpoint: function () {
		if (!this.get('canEdit')) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'profiles',
					value: this.get('profileKey')
				}
			]);
		}
		else {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'profiles'
				}
			]);
		}
	},
	parse: function (model) {
		model = model ? model : {};

		model.theme = _.defaults(model && model.theme ? model.theme : {}, this.defaultTheme);

		if (this.groups == null) {
			this.groups = new PJQ.collections.groups.Groups(model.groups, {
				groupLevels: 2
			});
		}
		else {
			this.groups.reset(_.size(model.groups) > 0 ? model.groups : null);
			this.groups.options.groupLevels = 2;
		}

		if (this.projectReferences) {
			this.projectReferences.reset(model.projectReferences);
		}
		else {
			this.projectReferences = new PJQ.collections.prequal.ProjectReferences(model.projectReferences);
		}

		if (this.companyPhotos) {
			this.companyPhotos.reset(model.companyPhotos);
		}
		else {
			this.companyPhotos = new PJQ.collections.contacts.CompanyPhotos(model.companyPhotos);
		}

		return model;
	},
	beforeSave: function () {
		this.set('projectReferences', this.projectReferences.toJSON());
		this.set('companyPhotos', this.companyPhotos.toJSON());
	},
	restoreDefaultTheme: function () {
		this.set('theme', this.defaultTheme);
	}
});
//Views
PJQ.views.profile = {};

PJQ.views.profile.CompanyProfile = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Company-Profile')
	},
	events: {
		'click .profile-edit': 'edit',
		'click .profile-view-qualification': 'viewScreenings',
		'click .profile-add-logo': 'addLogo',
		'click .profile-nav-item': 'tabActivated',
		'click .profile-project-reference-photo': 'viewReferencePhotoClick',
		'click .profile-project-reference-photo-delete': 'deleteReferencePhoto',
		'click .profile-company-photo': 'viewCompanyPhotoClick',
		'click .profile-company-photo-delete': 'deleteCompanyPhoto',
		'click .profile-cancel-edit': 'cancelEdit',
		'click .profile-theme-restore-defaults': 'restoreDefaultTheme',
		'click .profile-save': 'save'
	},
	beforeFirstRender: function () {
		if (this.model == null) {
			if (_.size(this.options.key) > 0) {
				this.model = new PJQ.models.profile.CompanyProfile({
					profileKey: this.options.key
				});
			}
			else {
				this.model = new PJQ.models.profile.CompanyProfile();
			}
		}

		this.model.fetch({
			success: _.bind(function () {
				this.render();
			}, this)
		})
	},
	beforeRender: function () {
		this.mapId = 'rmap_' + _.uniqueId();
		this.groupLabel = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.GROUP_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LABEL) : "Trades";
		this.maxGroups = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.RESTRICT_GROUP_COUNT) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.RESTRICT_GROUP_COUNT) : 10;
		this.renderData = {
			model: this.model,
			isEdit: this.isEdit,
			canEdit: this.model.get('canEdit'),
			mapId: this.mapId,
			groupLabel: this.groupLabel,
			maxGroups: this.maxGroups
		};
		this.activateTabId = this.$('.tab-pane.active').attr('id');
	},
	afterRender: function () {
		if (!this.model.isFetched) {
			this.loader = new PJQ.Loader(this.$el);
		}
		else {
			if (this.loader) {
				this.loader.remove();
				this.loader = null;
			}

			if (_.size(this.options.activateTab) > 0) {
				this.activateTab(this.options.activateTab);
				this.options.activateTab = null;
			}
			else if (_.size(this.activateTabId) > 0) {
				this.$('.nav-link[href="#' + this.activateTabId + '"]').tab('show');
				this.activateTabId = null;
			}

			this.renderLogo();
			this.renderTheme();
			this.renderOfficeLocationMap();
			this.renderWorkAreaMap();
			if (this.isEdit) {
				this.renderThemeEditor();
				this.renderGroupSelector();
				this.renderToolbar();
				this.renderProjectReferencePhotoUploaders();
				this.renderCompanyPhotoUploader();
				new PJQ.Binder(this.$el, this.model, {
					watchElements: [
						'input',
						'textarea'
					]
				});
			}

			if (this.options.projectReferenceId > 0 && this.options.projectReferencePhotoId > 0) {
				let reference = this.model.projectReferences.get(this.options.projectReferenceId);
				if (reference != null) {
					let photo = reference.photos.get(this.options.projectReferencePhotoId);
					if (photo != null) {
						this.viewReferencePhoto(reference, photo);
						this.$('.nav-link[href="#profileProjects"]').tab('show');
					}
				}
				this.options.projectReferenceId = null;
				this.options.projectReferencePhotoId = null;
			}
		}
	},
	activateTab: function (tab) {
		switch (tab ? tab.toLowerCase() : null) {
			case 'workareas':
				tab = 'profileWorkAreas';
				break;
			case 'projectreferences':
				tab = 'profileProjects';
				break;
			case 'photos':
				tab = 'profilePhotoGallery';
				break;
			default:
				tab = 'profileCompanyInfo';
				break;
		}
		this.$('.nav-link[href="#' + tab + '"]').tab('show');
	},
	tabActivated: function (e) {
		let newTabId = $(e.target).attr('href').replace('#', ''),
			route;
		switch (newTabId.toLowerCase()) {
			case 'profileworkareas':
				this.workAreaMap.refresh();
				this.refreshWindow();
				route = 'workareas';
				break;
			case 'profileprojects':
				route = 'projectreferences';
				break;
			case 'profilephotogallery':
				route = 'photos';
				break;
		}
		PJQ.app.router.navigate(PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'profiles',
				value: this.model.id
			},
			{
				endpoint: route
			}
		]));
	},
	renderLogo: function (base64) {
		if(_.size(base64) > 0 || _.size(this.model.get('logoURL')) > 0){
			let $logo = $('<img>', {
				class: 'max-wd-100p max-ht-100p'
			});
			$logo.on('load', function () {
				$logo.css('margin-top', ((120 - $logo.height()) / 2).toString() + 'px');
			});
			if (_.size(base64) > 0) {
				$logo.attr('src', base64);
			} else {
				$logo.attr('src', PJQ.helpers.urlHelpers.buildAPIURL(this.model.get('logoURL'), false, false, true));
			}
			this.$('.profile-logo-container').html($logo);
		}
	},
	refreshWindow: function() {
		setTimeout(function(){ window.dispatchEvent(new Event('resize')); }, 50);
	},
	renderThemeEditor: function () {
		let theme = this.model.get('theme');
		new PJQ.colors.ColorPicker(this.$('.profile-theme-header'), {
			format: 'hex',
			color: theme.headerBackgroundColor,
			onChange: _.bind(function (value) {
				theme.headerBackgroundColor = value;
				this.toolbar.autoShowToolbar();
				this.renderTheme();
			}, this)
		});

		new PJQ.colors.ColorPicker(this.$('.profile-theme-nav-items'), {
			format: 'hex',
			color: theme.navMenuTextColor,
			onChange: _.bind(function (value) {
				theme.navMenuTextColor = value;
                this.toolbar.autoShowToolbar();
				this.renderTheme();
			}, this)
		});

		new PJQ.colors.ColorPicker(this.$('.profile-theme-section-header'), {
			format: 'hex',
			color: theme.sectionHeaderTextColor,
			onChange: _.bind(function (value) {
				theme.sectionHeaderTextColor = value;
                this.toolbar.autoShowToolbar();
				this.renderTheme();
			}, this)
		});

		new PJQ.colors.ColorPicker(this.$('.profile-theme-section-body'), {
			format: 'hex',
			color: theme.sectionBodyTextColor,
			onChange: _.bind(function (value) {
				theme.sectionBodyTextColor = value;
                this.toolbar.autoShowToolbar();
				this.renderTheme();
			}, this)
		});
	},
	renderGroupSelector: function () {
		this.groupSelector = new PJQ.views.groups.GroupSelector({
			el: this.$('.profile-group-selector'),
            onSelect: _.bind(function(){
                this.toolbar.renderChangedCount();
            },this),
			selectedGroupIds: this.model.groups.getGroupIds(),
			isPublicGroups: true,
			isEnableSelectAll: false,
			maxGroups: this.maxGroups,
            isDisableParents: true
		});
	},
	renderOfficeLocationMap: function () {
		let officeLocationMap = new PJQ.maps.GoogleMap(this.$('.office-location-map-container'));
		_.each(this.model.get('offices'), function (office) {
			officeLocationMap.addMarker(office.latitude, office.longitude, {
				title: office.city + ', ' + office.state + ' ' + office.zip,
				infoWindowContent: office.city + ', ' + office.state + ' ' + office.zip
			});
		});
	},
	renderWorkAreaMap: function () {
		this.workAreaMap = new PJQ.views.workAreas.WorkAreaMap({
			el: this.$('.profile-work-areas'),
			contactId: this.model.get('primaryContactId'),
			isEdit: this.isEdit,
			isMapOnly: !this.isEdit,
			isInline: !this.isEdit,
			onDelete: _.bind(function(){
				this.toolbar.autoShowToolbar()
			},this),
			isSync: false,
			onFetch: _.bind(function () {
				if (_.size(this.workAreaMap.collection.models) > 0) {
					this.$('.profile-work-areas-nav-item').removeClass('hidden');
				}
				else if (this.model.get('canEdit') && !this.isEdit) {
					new PJQ.Alert(this.$('.profile-work-areas'), {
						type: 'primary',
						text: 'Click <strong><a href="javascript:void(0)" class="profile-edit">edit</a></strong> to add work areas. This section will currently be hidden to anybody viewing your profile.',
						isPrepend: true
					});
				}
			}, this)
		});
	},
	fetchModel: function() {
		this.model.fetch({
			success: _.bind(function () {
				this.render();
			}, this)
		})
	},
	renderToolbar: function() {
		this.toolbar = new PJQ.views.toolbars.ProfileSaveToolbar({
			model: this.model,
			el: this.$el,
			groupSelector: this.groupSelector,
			isEdit: this.isEdit,
			workAreaMap: this.workAreaMap.collection,
			onSave: _.bind(function () {
				this.save()
			}, this),
			onClose: _.bind(function () {
				this.fetchModel()
			}, this)
		})
	},
	renderTheme: function () {
		let theme = this.model.get('theme');
		this.$('.profile-main-header').css('background', theme.headerBackgroundColor);
		this.$('.profile-nav-item').css('cssText', 'color:' + theme.navMenuTextColor + ' !important');
		this.$('.profile-section-header').css('color', theme.sectionHeaderTextColor);
		this.$('.profile-section-body').css('color', theme.sectionBodyTextColor);

		let idealTextColor = PJQ.helpers.colorHelpers.idealLinkColorForBackground(theme.headerBackgroundColor),
			cancelEditButton = this.$('.profile-cancel-edit');
		if (_.size(cancelEditButton) > 0) {

			if (idealTextColor === '#fff') {
				cancelEditButton.removeClass('btn-secondary').addClass('btn-transparent-light');
			}
			else {
				cancelEditButton.removeClass('btn-transparent-light').addClass('btn-secondary');
			}
		}
		this.$('.profile-header-company-details').css('color', idealTextColor);
	},
	renderProjectReferencePhotoUploaders: function () {
		if (this.isEdit) {
			_.each(this.model.projectReferences.models, function (projectReference) {
				let uploader = new PJQ.views.files.FileUploader({
					el: this.$('.profile-project-reference[data-cid="' + projectReference.cid + '"]').find('.profile-project-reference-photo-upload'),
					allowedExtensions: PJQ.constants.files.imageExtensions,
					onSuccess: _.bind(function () {
						projectReference.set('uploadFolderId', uploader.options.uuid);
						this.$('.profile-project-reference[data-cid="' + projectReference.cid + '"]').find('.alert').remove();
                        this.toolbar.autoShowToolbar();
					}, this)
				});
			});
		}
	},
	viewReferencePhotoClick: function (e) {
		let referenceCid = $(e.currentTarget).closest('.profile-project-reference').data('cid'),
			reference = this.model.projectReferences.get(referenceCid),
			photo = reference.photos.get($(e.currentTarget).data('cid'));
		this.viewReferencePhoto(reference, photo);
	},
	viewReferencePhoto: function (reference, photo) {
		PJQ.app.view.renderPhotoViewer({
			image: photo.get('url')
		});
	},
	deleteReferencePhoto: function (e) {
		let deleteButton = $(e.currentTarget),
			photoContainer = deleteButton.parent('div'),
			referenceCid = deleteButton.closest('.profile-project-reference').data('cid'),
			reference = this.model.projectReferences.get(referenceCid),
			photo = reference.photos.get(deleteButton.siblings('.profile-project-reference-photo').data('cid'));

		this.deletedReferencePhotos.push(photo);
		photoContainer.animateCSS('fadeOut', function () {
			photoContainer.remove();
            this.toolbar.autoShowToolbar();
		});
	},
	viewCompanyPhotoClick: function (e) {
		this.viewCompanyPhoto(this.model.companyPhotos.get($(e.currentTarget).data('cid')));
	},
	viewCompanyPhoto: function (photo) {
		PJQ.app.view.renderPhotoViewer({
			image: photo.get('url')
		});
	},
	deleteCompanyPhoto: function (e) {
		let deleteButton = $(e.currentTarget),
			photoContainer = deleteButton.parent('div'),
			photo = this.model.companyPhotos.get(deleteButton.siblings('.profile-company-photo').data('cid'));

		this.deletedCompanyPhotos.push(photo);
		photoContainer.animateCSS('fadeOut', function () {
			photoContainer.remove();
		});
		this.toolbar.autoShowToolbar();
	},
	renderCompanyPhotoUploader: function () {
		if (this.isEdit) {
			let uploader = new PJQ.views.files.FileUploader({
				el: this.$('.profile-company-photo-upload'),
				allowedExtensions: PJQ.constants.files.imageExtensions,
				onSuccess: _.bind(function () {
					this.model.set('companyPhotoUploadFolderId', uploader.options.uuid);
					this.$('.profile-company-photo-alert').remove();
                    this.toolbar.autoShowToolbar();
				}, this)
			});
		}
	},
	addLogo: function () {
		let fileUploaderModal = new PJQ.views.files.FileUploaderModal({
			header: 'Upload Logo',
			isShowOkButton: false,
			maxFiles: 1,
			allowedExtensions: PJQ.constants.files.imageExtensions,
			onDone: _.bind(function (files) {
				if(_.size(files) > 0){
					let file = files[0];
					this.model.set('logoUploadFolderId', file.get('folder'));
					this.renderLogo(file.dataUrl);
					fileUploaderModal.removeModal();
					this.toolbar.autoShowToolbar();
				}
			}, this)
		});
	},
	restoreDefaultTheme: function () {
		this.model.restoreDefaultTheme();
		this.render();
	},
	viewScreenings: function () {
		PJQ.app.router.navigate('screenings', {
			trigger: true
		});
	},
	cancelEdit: function () {
		this.isEdit = false;
		this.model.fetch({
			success: _.bind(function () {
				this.render();
			}, this)
		})
	},
	edit: function () {
		this.isEdit = true;
		this.deletedReferencePhotos = [];
		this.deletedCompanyPhotos = [];
		this.render();
	},
	save: function () {
		this.groupSelector.hideError();
		if(this.groupSelector.getGroupsData().selected.length > this.groupSelector.maxGroups){
			this.groupSelector.showError("You may only select " + this.groupSelector.maxGroups + " " + this.groupLabel + "!");
			return
		}
		this.isEdit = false;
		this.$('.profile-cancel-edit').prop('disabled', true);
		this.$('.profile-save').prop('disabled', true).text('Saving...');

		if (_.size(this.deletedReferencePhotos) > 0) {
			_.each(this.deletedReferencePhotos, function (photo) {
				let projectReference = this.model.projectReferences.get(photo.get('projectReferenceId'));
				projectReference.photos.remove(photo);
				projectReference.set('photos', projectReference.photos.toJSON());
				photo.destroy();
			}, this);
			this.deletedReferencePhotos = [];
		}

		if (_.size(this.deletedCompanyPhotos) > 0) {
			_.each(this.deletedCompanyPhotos, function (photo) {
				photo.destroy();
			});
			this.model.companyPhotos.remove(this.deletedCompanyPhotos);
			this.deletedCompanyPhotos = [];
		}

		this.workAreaMap.save(_.bind(function () {
			this.model.groups = new PJQ.collections.groups.Groups(this.groupSelector.getGroupsData().selected, {
				masterUserId: this.model.groups.options.masterUserId
			});
			this.model.save({
				groups: this.model.groups.toJSON()
			}, {
				success: _.bind(function () {
					this.render();
				}, this)
			});
		}, this));
	}
});

//Models
PJQ.models.screenings = {};

PJQ.models.screenings.ScreeningClient = PJQ.models.BaseModel.extend({
	idAttribute: 'masterUserId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'contacts',
				value: this.get('contactId') > 0 ? this.get('contactId') : PJQ.app.session.contact.id
			},
			{
				endpoint: 'screenings',
				value: this.id
			}
		]);
	},
	parse: function (model) {
		if (model.terms) {
			if (model.terms instanceof PJQ.collections.screenings.ScreeningTerms)
				this.terms = model.terms;
			else
				this.terms = new PJQ.collections.screenings.ScreeningTerms(model.terms, {
					masterUserId: model.masterUserId
				});
		}
		else {
			this.terms = new PJQ.collections.screenings.ScreeningTerms(null, {
				masterUserId: model.masterUserId
			});
		}

		if (model.products) {
			if (model.products instanceof PJQ.collections.payment.Products)
				this.products = model.products;
			else
				this.products = new PJQ.collections.payment.Products(model.products);
		}
		else {
			this.products = new PJQ.collections.payment.Products();
		}

		if (model.categories) {
			if (model.categories instanceof PJQ.collections.screenings.ScreeningCategories)
				this.categories = model.categories;
			else
				this.categories = new PJQ.collections.screenings.ScreeningCategories(model.categories);
		}
		else {
			this.categories = new PJQ.collections.screenings.ScreeningCategories();
		}

		//Recursively set this client masterUserId to all children models
		//masterUserId is the root of all screening endpoints
		this.categories.options.masterUserId = model.masterUserId;
		_.each(this.categories.models, function (category) {
			category.set('masterUserId', model.masterUserId);

			category.items.options.masterUserId = model.masterUserId;
			_.each(category.items.models, function (item) {
				item.set('masterUserId', model.masterUserId);

				//Also set the screeningInviteItemId for all sub-items here
				//It is used for the API url
				item.attachments.options.masterUserId = model.masterUserId;
				item.attachments.options.screeningInviteItemId = item.id;
				_.each(item.attachments.models, function (attachment) {
					attachment.set({
						masterUserId: model.masterUserId,
						screeningInviteItemId: item.id
					});
				});

				_.each(item.comments.models, function (comment) {
					comment.set({
						masterUserId: model.masterUserId,
						screeningInviteItemId: item.id
					});
				});

				_.each(item.questions.models, function (question) {
					question.set({
						masterUserId: model.masterUserId,
						screeningInviteItemId: item.id
					});
				});
			});
		});

		if (model.prequal) {
			if (model.prequal instanceof PJQ.models.prequal.Prequal)
				this.prequal = model.prequal;
			else
				this.prequal = new PJQ.models.prequal.Prequal(model.prequal);
		}
		else {
			this.prequal = new PJQ.models.prequal.Prequal();
		}

		if (model.sampleDocuments) {
			if (model.sampleDocuments instanceof PJQ.collections.screenings.SampleDocuments)
				this.sampleDocuments = model.sampleDocuments;
			else
				this.sampleDocuments = new PJQ.collections.screenings.SampleDocuments(model.sampleDocuments, {
					masterUserId: model.masterUserId
				});
		}
		else {
			this.sampleDocuments = new PJQ.collections.screenings.SampleDocuments(null, {
				masterUserId: model.masterUserId
			});
		}

		if (this.preferences && model.preferences) {
			this.preferences.set(model.preferences);
		}
		else {
			this.preferences = new PJQ.models.preferences.Preferences(model.preferences);
		}

		return model;
	},
	getItemStatusStats: function () {
		let statuses = {};
		_.each(this.categories.models, function (category) {
			_.each(category.items.models, function (item) {
				if (statuses[item.get('status').screeningStatusId] == null) {
					statuses[item.get('status').screeningStatusId] = {
						id: item.get('status').screeningStatusId,
						name: item.get('status').name,
						color: item.get('status').textColor,
						count: 1,
						sortOrder: item.get('status').sortOrder
					};
				}
				else {
					statuses[item.get('status').screeningStatusId].count++;
				}
			});
		});
		return statuses;
	},
	getAttentionItems: function () {
		let attentionItems = [];
		_.each(this.categories.models, function (category) {
			attentionItems.push(...category.getAttentionItems());
		});
		return attentionItems;
	},
	hasItems: function () {
		return _.find(this.categories.models, function (category) {
			return _.size(category.items.models) > 0;
		}) != null;
	},
	checkNeedsTerms: function () {
		return _.find(this.terms.models, function (term) {
			return term.get('isActive') && !term.get('isAccepted')
		}) != null;
	}
});

PJQ.models.screenings.ScreeningCategory = PJQ.models.BaseModel.extend({
	idAttribute: 'screeningCategoryId',
	parse: function (model) {
		if (model.items) {
			if (model.items instanceof PJQ.collections.screenings.ScreeningItems)
				this.items = model.items;
			else
				this.items = new PJQ.collections.screenings.ScreeningItems(model.items);
		}
		else {
			this.items = new PJQ.collections.screenings.ScreeningItems();
		}

		if (model.grades) {
			if (model.grades instanceof PJQ.collections.screenings.Grades)
				this.grades = model.grades;
			else
				this.grades = new PJQ.collections.screenings.Grades(model.grades);
		}
		else {
			this.grades = new PJQ.collections.screenings.Grades();
		}
		return model;
	},
	getAttentionItems: function () {
		return _.filter(this.items.models, function (item) {
			return item.get('status').needsAttention;
		}, this);
	}
});

PJQ.models.screenings.Grade = PJQ.models.BaseModel.extend({
	idAttribute: 'screeningGradeId'
});

PJQ.models.screenings.ScreeningItem = PJQ.models.BaseModel.extend({
	idAttribute: 'screeningItemId'
});

PJQ.models.screenings.ScreeningInviteItem = PJQ.models.screenings.ScreeningItem.extend({
	idAttribute: 'screeningInviteItemId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'screenings',
				value: this.get('masterUserId')
			},
			{
				endpoint: 'items',
				value: this.id
			}
		]);
	},
	submitProcessing: function (callback) {
		this.setStatus(PJQ.constants.screenings.statuses.IN_PROCESS, callback);
	},
	moveWaiting: function (callback) {
		this.setStatus(PJQ.constants.screenings.statuses.WAITING, callback);
	},
	setStatus: function (statusId, callback) {
		this.get('status').screeningStatusId = statusId;
		this.save(null, {
			success: _.bind(callback, this)
		});
	},
	updateExpiresOn: function (expiresOn, callback) {
		this.save({
			expiresOn: expiresOn
		}, {
			success: _.bind(callback, this)
		});
	},
	parse: function (model) {
		if (model.comments) {
			if (model.comments instanceof PJQ.collections.screenings.ScreeningComments)
				this.comments = model.comments;
			else
				this.comments = new PJQ.collections.screenings.ScreeningComments(model.comments);
		}
		else {
			this.comments = new PJQ.collections.screenings.ScreeningComments();
		}

		if (model.attachments) {
			if (model.attachments instanceof PJQ.collections.screenings.ScreeningItemAttachments)
				this.attachments = model.attachments;
			else {
				this.attachments = new PJQ.collections.screenings.ScreeningItemAttachments(model.attachments);
			}
		}
		else {
			this.attachments = new PJQ.collections.screenings.ScreeningItemAttachments(null);
		}

		if (model.questions) {
			if (model.questions instanceof PJQ.collections.screenings.ScreeningClientQuestions)
				this.questions = model.questions;
			else
				this.questions = new PJQ.collections.screenings.ScreeningClientQuestions(model.questions);
		}
		else {
			this.questions = new PJQ.collections.screenings.ScreeningClientQuestions();
		}

		return model;
	}
});

PJQ.models.screenings.ScreeningComment = PJQ.models.BaseModel.extend({
	idAttribute: 'screeningItemCommentId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'screenings',
				value: this.get('masterUserId')
			},
			{
				endpoint: 'items',
				value: this.get('screeningInviteItemId')
			},
			{
				endpoint: 'comments',
				value: this.id
			}
		]);
	},
	parse: function (model) {
		if (!model)
			return model;

		if (model.createdBy != null) {
			this.createdBy = new PJQ.models.projectContacts.ProjectContact(model.createdBy);
		}

		return model;
	}
});

PJQ.models.screenings.ScreeningItemAttachment = PJQ.models.files.File.extend({
	idAttribute: 'attachmentId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'screenings',
				value: this.get('masterUserId')
			},
			{
				endpoint: 'items',
				value: this.get('screeningInviteItemId')
			},
			{
				endpoint: 'attachments',
				value: this.id
			}
		]);
	}
});

PJQ.models.screenings.ScreeningQuestion = PJQ.models.BaseModel.extend({
	idAttribute: 'screeningItemQuestionId'
});

PJQ.models.screenings.ScreeningClientQuestion = PJQ.models.screenings.ScreeningQuestion.extend({
	idAttribute: 'screeningItemQuestionId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'screenings',
				value: this.get('masterUserId')
			},
			{
				endpoint: 'items',
				value: this.get('screeningInviteItemId')
			},
			{
				endpoint: 'questions',
				value: this.id
			},
			{
				endpoint: 'response'
			}
		]);
	}
});

PJQ.models.screenings.SampleDocument = PJQ.models.BaseModel.extend({
	idAttribute: 'screeningSampleDocumentId',
	download: function () {
		PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'screenings',
				value: this.get('masterUserId')
			},
			{
				endpoint: 'sampledocuments',
				value: this.id
			}
		]));
	}
});

PJQ.models.screenings.ScreeningTerm = PJQ.models.BaseModel.extend({
	idAttribute: 'screeningTermsId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'screenings',
				value: this.get('masterUserId')
			},
			{
				endpoint: 'terms',
				value: this.id
			}
		]);
	}
});


//Collections
PJQ.collections.screenings = {};

PJQ.collections.screenings.ScreeningClients = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.screenings.ScreeningClient,
	endpoint: function () {
		if (this.options.masterUserId > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'contacts',
					value: this.options.contact.id
				},
				{
					endpoint: 'screenings'
				}
			], [
				{
					parameter: 'masterUserId',
					value: this.options.masterUserId
				}
			]);
		}
		else {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'contacts',
					value: this.options.contact.id
				},
				{
					endpoint: 'screenings'
				}
			]);
		}
	},
	hasItems: function () {
		let hasItems = false;
		_.each(this.models, function (client) {
			if (client.hasItems()) {
				hasItems = true;
			}
		});
		return hasItems;
	}
});

PJQ.collections.screenings.ScreeningCategories = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.screenings.ScreeningCategory,
	getItems: function () {
		let items = [];
		_.each(this.models, function (category) {
			_.each(category.items.models, function (item) {
				items.push(item);
			});
		});
		return items;
	}
});

PJQ.collections.screenings.Grades = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.screenings.Grade
});

PJQ.collections.screenings.ScreeningItems = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.screenings.ScreeningInviteItem
});

PJQ.collections.screenings.ScreeningComments = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.screenings.ScreeningComment
});

PJQ.collections.screenings.ScreeningItemAttachments = PJQ.collections.files.Files.extend({
	model: PJQ.models.screenings.ScreeningItemAttachment,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'screenings',
				value: this.options.masterUserId
			},
			{
				endpoint: 'items',
				value: this.options.screeningInviteItemId
			},
			{
				endpoint: 'attachments'
			}
		]);
	}
});

PJQ.collections.screenings.ScreeningQuestions = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.screenings.ScreeningQuestion
});

PJQ.collections.screenings.ScreeningClientQuestions = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.screenings.ScreeningClientQuestion
});

PJQ.collections.screenings.SampleDocuments = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.screenings.SampleDocument,
	download: function () {
		PJQ.files.queueDownload(PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'screenings',
				value: this.options.masterUserId
			},
			{
				endpoint: 'sampledocuments'
			}
		]));
	}
});

PJQ.collections.screenings.ScreeningTerms = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.screenings.ScreeningTerm,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'screenings',
				value: this.options.masterUserId > 0 ? this.options.masterUserId : PJQ.constants.publicUserId
			},
			{
				endpoint: 'terms'
			}
		]);
	}
});
//Views
PJQ.views.screenings = {};

PJQ.views.screenings.ScreeningDashboard = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Screening-Editor-Dashboard'),
		subTemplates: {
			faq: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-FAQ')
		},
		baseFaqItems: [
			{
				q: "Why am I being asked to complete this form?",
				a: "The requesting General Contractor, in an effort to improve their bidding process and ensure data consistency among their subcontractors have asked all subcontractors to keep on file updated company qualification data."
			},
			{
				q: "How often do I need to update this information?",
				a: "You have the ability to update your information at any time.  Only certain performance data will be required to updated annually as a majority of your company information may not change."
			},
			{
				q: "I've worked with the requesting General Contractor many times in the past, why am I being asked to complete this now?",
				a: "The requesting General Contractor is updating their database so that all subcontractors have current and consistent company and performance information on file regardless of previous contract awards."
			},
			{
				q: "What if I don’t know the answers to all the questions being asked?",
				a: "If you do not have the information on hand, you may return to the form once you are ready.  All of your previously entered information will remain intact."
			},
			{
				q: "I've completed every field but the form is not at 100%.",
				a: "Fields that are incomplete will be highlighted in red. Common fields that are overlooked as complete are phone number fields which require all 10 digits to be considered complete.  You can view the left hand menu to determine which section is incomplete."
			},
			{
				q: "One of our divisions/offices already filled in this information and it's all the same. Do I need to do it again?",
				a: "If you have received the request multiple times to your same email address, please contact the General Contractor as this means you have been entered twice in the address book of the General Contractor. If the requests have gone to different contacts within your company and each contact is responsible for submitting bids for their respective office/division, then yes each contact will need to fill out the form."
			}
		],
		proqualFaqItems: [
			{
				q: "I have never received a bid or job from this GC, why should I complete this form?",
				a: "In an effort to make better subcontracting decisions and provide subcontractors with the right opportunities, the data on this form will help us get you the requests that match your specialties with our upcoming work.  Filling out this form will increase the likelihood that you will be considered for a project in the future."
			},
			{
				q: "I only want to complete this form if I'm awarded a job.",
				a: "The requesting General Contractor is utilizing the this data in addition to information provided with bids. By taking the 15 minutes to complete this now will them know who is serious about bidding."
			}
		]
	},
	events: {
		'click .network-upgrade': 'networkUpgrade',
		'click .edit-profile': 'editProfile',
		'click .view-prequal-faq': 'viewFaq',
		'click .screening-back-to-dashboard': 'backToDashboard',
		'click .screening-dashboard-view-client': 'renderClientScreenings',
		'click .prequal-export-pdf-user': 'exportPDF',
		'click .prequal-export-excel-user': 'exportExcel'
	},
	afterRender: function () {
		if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DODGE_CRM) && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DODGE_WG)) {
			this.$('.network-upgrade,.edit-profile').removeClass('hidden');
		}

		if (!this.collection.hasItems()) {
			this.$('.screening-back-to-dashboard').addClass('hidden');

			let callback = _.bind(function (logoURL) {
				let publicClient = new PJQ.models.screenings.ScreeningClient({
					masterUserId: this.collection.options.masterUserId,
					logoURL: logoURL,
					prequal: new PJQ.models.prequal.Prequal({
						masterUserId: this.collection.options.masterUserId,
						contact: this.collection.options.contact
					})
				});
				this.renderClientPrequal(publicClient);
			}, this);
			if (this.collection.options.masterUserId === PJQ.constants.publicUserId) {
				callback(PJQ.constants.publicLogoURL);
			}
			else {
				new PJQ.ajax.Request({
					endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
						{
							endpoint: 'users',
							value: this.collection.options.masterUserId
						},
						{
							endpoint: 'logo'
						}
					])
				}).get().done(function (response) {
					callback(response.url);
				});
			}
		}
		else {
			this.renderClients();
		}
	},
	renderNavClient: function (client) {
		if (client != null) {
			this.$('.screening-nav-client-info').html($('<img/>', {
				src: client.get('logoURL'),
				class: 'max-ht-75p max-wd-100'
			}));
			this.$('.screening-nav-client').animateCSS('slideDown');
		}
		else {
			this.$('.screening-nav-client').animateCSS('slideUp', function () {
				this.$('.screening-nav-client-info').empty();
			}, this);
		}
	},
	renderClients: function () {
		if (this.dashboardClients) {
			this.dashboardClients.render();
		}
		else {
			this.dashboardClients = new PJQ.views.screenings.ScreeningDashboardClients({
				el: this.$('.screening-dashboard-body'),
				collection: this.collection,
				dashboard: this
			});
		}
		this.$('.screening-dashboard-body').animateCSS('fadeIn');
	},
	renderClientScreenings: function (client, filter) {
		if (!(client instanceof PJQ.models.screenings.ScreeningClient)) {
			client = this.contextClient;
		}
		else {
			this.contextClient = client;
		}

		let percentComplete = client.prequal.get('percentComplete');
		if (percentComplete != null && percentComplete < 100 && client.get('isPrequalActive')) {
			this.renderClientPrequal(client);
		}
		else {
			this.checkPayment(client, _.bind(function () {
				this.checkTerms(client, _.bind(function () {
					if (this.headerAlert) {
						this.headerAlert.destroy();
						this.headerAlert = null;
					}

					this.$('.screening-back-to-dashboard,.screening-dashboard-nav-extend').animateCSS('slideDown');

					if (this.prequalEditor != null) {
						this.$('.screening-dashboard-view-client, .btn-export-prequal').animateCSS('slideUp');
						this.prequalEditor.remove();
						this.prequalEditor = null;
					}
					else if (this.dashboardClients != null) {
						this.dashboardClients.remove();
						this.dashboardClients = null;
					}

					this.loader = new PJQ.Loader(this.$('.screening-dashboard-body'));

					client.fetch({
						success: _.bind(function () {
							this.loader.remove();
							this.loader = null;
							this.screeningEditor = new PJQ.views.screenings.ScreeningClientEditor({
								el: this.$('.screening-dashboard-body'),
								model: client,
								filter: filter,
								navContainer: this.$('.screening-dashboard-nav-extend')
							});
						}, this)
					});

					this.renderNavClient(client);
				}, this));
			}, this))
		}
	},
	checkPayment: function (client, callback) {
		if (!client.get('isPaid')) {
			new PJQ.views.payment.PaymentModal({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'contacts',
						value: PJQ.app.session.contact.id
					},
					{
						endpoint: 'screenings',
						value: client.get('masterUserId')
					},
					{
						endpoint: 'payment'
					}
				]),
				onComplete: _.bind(callback, this),
				products: client.products
			});
		}
		else {
			callback();
		}
	},
	exportPDF: function () {
		this.export(false);
	},
	exportExcel: function () {
		this.export(true);
	},
	export: function (isExcel) {
		if (this.contextClient) {
			let prequal = this.contextClient.prequal,
				contactId = prequal.contact.get('contactId')
			PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'contacts',
					value: contactId
				},
				{
					endpoint: 'prequal'
				},
				{
					endpoint: 'export'
				}
			], [
				{
					parameter: 'masterUserId',
					value: this.contextClient.get('masterUserId') > 0 ? this.contextClient.get('masterUserId') : (PJQ.app.session.preferences.hasPref('portalOwner') ? PJQ.app.session.preferences.getPref('portalOwner') : PJQ.app.session.get('masterUserId'))
				},
				{
					parameter: 'isExcel',
					value: isExcel
				}
			]));
		}
		else {
			PJQ.notifications.notify.errorNotify({
				message: 'Export failed.'
			});
		}
	},
	checkTerms: function (client, callback) {
		if (client.checkNeedsTerms()) {
			new PJQ.views.screenings.ScreeningTermsModal({
				collection: client.terms,
				onComplete: _.bind(callback, this)
			});
		}
		else {
			callback();
		}
	},
	renderClientPrequal: function (client) {
		if (!(client instanceof PJQ.models.screenings.ScreeningClient)) {
			client = this.contextClient;
		}
		else {
			this.contextClient = client;
		}

		if (client.checkNeedsTerms()) {
			new PJQ.views.screenings.ScreeningTermsModal({
				collection: client.terms,
				onComplete: _.bind(function () {
					this.renderClientPrequalUI(client);
				}, this)
			});
		}
		else {
			this.renderClientPrequalUI(client);
		}
	},
	renderClientPrequalUI: function (client) {
		this.renderNavClient(client);

		this.$('.screening-dashboard-body').animateCSS('fadeOut', function () {
			if (this.collection.hasItems()) {
				this.$('.screening-back-to-dashboard,.screening-dashboard-nav-extend').animateCSS('slideDown');
			}

			if (this.dashboardClients != null) {
				this.dashboardClients.remove();
				this.dashboardClients = null;
			}

			this.$('.screening-dashboard-body').animateCSS('fadeIn');
			this.loader = new PJQ.Loader(this.$('.screening-dashboard-body'));

			client.prequal.fetch({
				success: _.bind(function () {
					if (client.hasItems()) {
						this.$('.screening-dashboard-view-client').prop('disabled', true).animateCSS('slideDown');
						this.$('.btn-export-prequal').animateCSS('slideDown');

						client.prequal.on('change:percentComplete', function () {
							this.renderCriteriaButton(client);
						}, this);

						if (client.get('isPrequalActive')) {
							this.headerAlert = new PJQ.Alert(this.$('.screening-dashboard-header'), {
								type: 'warning',
								text: '<strong>' + client.get('clientName') + '</strong> requires your qualification statement to be 100% complete before viewing any requested criteria.',
								isPrepend: true,
								animation: {
									in: 'fadeIn',
									out: 'fadeOut'
								}
							});
						}
					}

					this.renderCriteriaButton(client);

					this.prequalEditor = new PJQ.views.prequal.PrequalEditor({
						el: this.$('.screening-dashboard-body'),
						model: client.prequal,
						clients: this.collection,
						preferences: client.preferences,
						navContainer: this.$('.screening-dashboard-nav-extend'),
						dashboard: this
					});
					this.loader.remove();
					this.loader = null;
				}, this),
				error: function (model, result) {
					new PJQ.logging.Debug(PJQ.logging.LoggingActions.PJQPROFILE_GET_SCREENINGS, {
						model: model,
						result: result
					});
				}
			});
		}, this);
	},
	renderCriteriaButton: function (client) {
		let percentComplete = client.prequal.get('percentComplete');
		this.$('.screening-dashboard-view-client').prop('disabled', percentComplete != null && percentComplete < 100);
	},
	backToDashboard: function () {
		this.contextClient = null;

		this.renderNavClient();

		if (this.headerAlert) {
			this.headerAlert.destroy();
			this.headerAlert = null;
		}

		this.$('.screening-back-to-dashboard,.screening-dashboard-view-client,.screening-dashboard-nav-extend').animateCSS('slideUp');
		this.$('.screening-dashboard-body').animateCSS('fadeOut', function () {
			if (this.prequalEditor) {
				this.prequalEditor.remove();
				this.prequalEditor = null;
			}
			else if (this.screeningEditor) {
				this.screeningEditor.remove();
				this.screeningEditor = null;
			}
			this.renderClients();
		}, this);
	},
	networkUpgrade: function () {
		let redirectURL = 'http://network.panteratools.com/pantera-network/?';
		if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_PROQUAL_PORTAL))
			redirectURL = 'http://demo.panteratools.com/verified-network-long-video-page/?';
		//todo: load directorysettings from api
		else if (directorySettings.IsNetworkContact && directorySettings.NetworkVerificationLevel == 1)
			redirectURL = 'http://demo.panteratools.com/verified-network-landing-pages-from-pn/?';
		window.open(redirectURL + this.model.contact.id.toString(), '_blank');
	},
	editProfile: function () {
		PJQ.app.router.navigate('profile', {
			trigger: true
		});
	},
	viewFaq: function () {
		let faqItems = this.options.baseFaqItems;
		if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DODGE_CRM) && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DODGE_WG))
			faqItems = _.union(faqItems, this.options.proqualFaqItems);
		new PJQ.views.BaseModal({
			header: "Frequently Asked Questions",
			isShowOkButton: false,
			isShowCancelButton: true,
			cancelButtonText: "Close",
			body: PJQ.templating.TemplateRenderer.parseTemplate(this.options.subTemplates.faq, {
				faqItems: faqItems
			}).html(),
			okButtonText: "Ok"
		});
	},
});

PJQ.views.screenings.ScreeningDashboardClients = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Screening-Editor-Dashboard-Clients')
	},
	events: {
		'click .btn-screening-view-prequal': 'viewClientPrequal',
		'click .btn-screening-view-client': 'viewClientScreenings',
		'click .screening-view-client-attention': 'viewClientScreeningsAttention'
	},
	renderData: function(){
		return {
			collection: this.collection
		};
	},
	afterRender: function () {
		_.each(this.collection.models, function (model) {
			let $clientElement = this.getClientElement(model.cid),
				statusStats = model.getItemStatusStats(),
				statusLabels = [],
				statusCounts = [],
				statusColors = [];

			//Render prequal progress and attach events
			if (model.prequal != null) {
				let progressBar = new PJQ.progress.ProgressBar($clientElement.find('.prequal-progress'), {
					isShowPercentage: true,
					height: 30,
					progress: model.prequal.get('percentComplete')
				});
				model.prequal.on('change:percentComplete', function () {
					progressBar.updateProgress(model.prequal.get('percentComplete'));
				}, this)
			}

			//Render screening items attention link
			let attentionItemsCount = _.size(model.getAttentionItems()),
				$attentionContainer = $clientElement.find('.screening-view-client-attention-container');
			if (attentionItemsCount > 0) {
				let $element = $('<button>', {
					class: 'btn btn-link text-danger screening-view-client-attention font-weight-bold fs-14'
				});
				if (attentionItemsCount === 1) {
					$element.text(attentionItemsCount.toString() + ' item requires your attention!');
				}
				else {
					$element.text(attentionItemsCount.toString() + ' items require your attention!');
				}
				$attentionContainer.html($element);
			}
			else {
				$attentionContainer.empty();
			}

			//Render screening items chart
			_.each(statusStats, function (status) {
				statusLabels.push(status.name);
				statusCounts.push(status.count);
				statusColors.push(status.color);
			});
			if (model.get('isPaid')) {
				new PJQ.charts.Chart($clientElement.find('.screening-items-status-chart'), {
					type: 'doughnut',
					height: 300,
					width: 300,
					data: {
						labels: statusLabels,
						datasets: [
							{
								data: statusCounts,
								backgroundColor: statusColors
							}
						]
					},
					onClick: _.bind(function (clickedSegments) {
						let clickedStatuses = _.map(clickedSegments, function (segment) {
							return segment._model.label.toLowerCase();
						});
						if (_.size(clickedStatuses) > 0) {
							this.options.dashboard.renderClientScreenings(model, clickedStatuses);
						}
					}, this)
				});
			}
		}, this);
	},
	viewClientPrequal: function (e) {
		if (this.options.dashboard) {
			this.options.dashboard.renderClientPrequal(this.collection.get($(e.currentTarget).closest('.screening-client').data('cid')));
		}
	},
	viewClientScreenings: function (e) {
		this.options.dashboard.renderClientScreenings(this.collection.get($(e.currentTarget).closest('.screening-client').data('cid')));
	},
	viewClientScreeningsAttention: function (e) {
		this.options.dashboard.renderClientScreenings(this.collection.get($(e.currentTarget).closest('.screening-client').data('cid')), 'attention');
	},
	getClientElement: function (cid) {
		return this.$('.screening-client[data-cid="' + cid + '"]');
	}
});

PJQ.views.screenings.ScreeningClientEditor = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Screening-Editor-Client'),
		subTemplates: {
			category: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Screening-Editor-Category'),
			sampleDocuments: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Screening-Sample-Documents')
		},
		canManage: false,
		isAdmin: false
	},
	events: {
		'click .btn-view-packages': 'viewPackages',
		'keyup .screening-items-search': 'filterItems',
		'click .screening-items-clear-filters': 'clearFilters'
	},
	beforeRender: function () {
		this.renderData = {
			model: this.model,
			canManage: this.options.canManage === true,
			isAdmin: this.options.isAdmin === true,
			filterItemStatuses: this.model.getItemStatusStats()
		};
	},
	afterRender: function () {
		this.filterPicker = new PJQ.inputs.Selectpicker({
			el: this.$('.screening-items-filter'),
			onChange: _.bind(this.filterItems, this),
			isMultiple: true,
			isGrouped: true,
			defaultValue: this.options.filter,
			noneSelectedText: 'No Filters'
		});

		this.renderNav();
		this.renderCategories();
		this.$('.screening-editor-client').animateCSS('fadeIn');

		let helpAlertText = 'Please click the "View Requested Criteria" box(s) below for EACH enrollment listed to complete the enrollment registration(s).<br>Once enrolled, requested documentation can be uploaded & submitted for compliance processing.<br>Updated documentation is requested for all Items with a status of "Waiting", "Incomplete", or "Expired".<br>Items listed as "Global" link across  enrollments, eliminating the need to upload the same document to each enrollment.';
		$('.screening-dashboard-header').empty();
		new PJQ.Alert($('.screening-dashboard-header'), {
			text: helpAlertText
		});
	},
	viewPackages: function(){
		new PJQ.views.screenings.ScreeningInvitePackagesModal({
			packages: this.model.get('packages')
		});
	},
	renderNav: function () {
		if (_.size(this.options.navContainer) > 0) {
			if (this.$nav != null) {
				this.$nav.remove();
				this.$nav = null;
			}

			this.$nav = $('<div>', {
				class: 'screening-nav-container hidden'
			});
			this.addElements(this.$nav);
			this.options.navContainer.prepend(this.$nav);

			if (_.size(this.model.sampleDocuments.models) > 0) {
				this.renderSubTemplate(true, this.options.subTemplates.sampleDocuments, this.$nav, {
					model: this.model
				});
				this.$nav.find('.screening-sample-documents-download-all').on('click', _.bind(this.downloadAllSampleDocuments, this));
				this.$nav.find('.screening-sample-document-download').on('click', _.bind(this.downloadSampleDocument, this));
				this.$nav.animateCSS('slideDown');
			}
		}
	},
	renderCategories: function () {
		let $categoriesContainer = this.$('.screening-editor-categories');
		this.categoryViews = [];
		_.each(this.model.categories.models, function (category) {
			//Bind any status change in any item to filterItems
			//This is because if the status changes, there may be a status filter and this item might need to be filtered out
			_.each(category.items.models, _.bind(function (item) {
				item.on('change:status', _.bind(this.filterItems, this));
			}, this));

			let $category = $('<div>', {
				class: 'screening-editor-category',
				'data-cid': category.cid
			});
			$categoriesContainer.append($category);
			let categoryView = new PJQ.views.screenings.ScreeningCategory({
				el: $category,
				model: category,
				client: this.model,
				canManage: this.options.canManage === true,
				isAdmin: this.options.isAdmin === true
			});
			this.categoryViews.push(categoryView);
		}, this);
	},
	filterItems: function () {
		let itemCids = _.map(this.getFilteredItems(), function (item) {
			return item.cid;
		});
		this.$('.screening-editor-item-toggle').each(function () {
			let $item = $(this);
			if (_.contains(itemCids, $item.data('cid'))) {
				$item.removeClass('hidden');
			}
			else {
				$item.addClass('hidden');
			}
		});

		this.$('.screening-editor-category').each(function () {
			if (_.size($(this).find('.nav-item.screening-editor-item-toggle:not(.hidden)')) > 0) {
				$(this).removeClass('hidden');

				//Ensure at least one of the tabs for this category that is shown is selected
				let showNav = $(this).find('.nav-item.screening-editor-item-toggle:not(.hidden)>.nav-link').first();
				if (_.size(showNav) > 0) {
					$(this).find('.nav-item.screening-editor-item-toggle.active').removeClass('active').removeClass('show');
					showNav.addClass('active show');
				}
			}
			else {
				$(this).addClass('hidden');
			}
		});

		_.each(this.categoryViews, function (categoryView) {
			categoryView.renderHeader();
		});
	},
	downloadAllSampleDocuments: function () {
		this.model.sampleDocuments.download();
	},
	downloadSampleDocument: function (e) {
		let sampleDocument = this.model.sampleDocuments.get($(e.currentTarget).data("cid"));
		sampleDocument.download();
	},
	getFilteredItems: function () {
		let searchFilter = this.getSearchFilter().toLowerCase(),
			filters = this.getStatusFilter(),
			items = this.model.categories.getItems();

		this.$('.screening-items-clear-filters').prop('disabled', _.size(searchFilter) === 0 && _.size(filters) === 0);

		if (_.size(searchFilter) > 0) {
			items = _.filter(items, function (item) {
				return item.get('name').toLowerCase().indexOf(searchFilter) !== -1;
			});
		}

		if (_.size(filters.general) > 0) {
			if (_.contains(filters.general, 'attention')) {
				items = _.filter(items, function (item) {
					return item.get('status').needsAttention;
				});
			}

			if (_.contains(filters.general, 'flagged')) {
				items = _.filter(items, function (item) {
					return item.get('isFlagged');
				});
			}
		}

		if (_.size(filters.statuses) > 0) {
			items = _.filter(items, function (item) {
				return _.contains(filters.statuses, item.get('status').name.toLowerCase());
			});
		}

		if (_.size(filters.categories) > 0) {
			let categoryItemIds = [];
			_.each(this.model.categories.models, function (category) {
				if (filters.categories.indexOf(category.get('name').toLowerCase()) !== -1) {
					_.each(category.items.models, function (item) {
						categoryItemIds.push(item.cid);
					});
				}
			});
			items = _.filter(items, function (item) {
				return _.contains(categoryItemIds, item.cid);
			})
		}

		return items;
	},
	getSearchFilter: function () {
		return this.$('.screening-items-search').val().trim();
	},
	getStatusFilter: function () {
		return this.filterPicker.getValue();
	},
	clearFilters: function () {
		this.filterPicker.deselectAll();
		this.$('.screening-items-search').val('');
		this.filterItems();
	}
});

PJQ.views.screenings.ScreeningCategory = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Screening-Editor-Category'),
		subTemplates: {
			header: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Screening-Editor-Category-Header')
		}
	},
	events: {
		'keyup .screening-items-search': 'filterItems',
		'click .screening-items-clear-filters': 'clearFilters'
	},
	beforeRender: function () {
		this.renderData = {
			model: this.model,
			canManage: this.options.canManage === true,
			isAdmin: this.options.isAdmin === true
		};
	},
	afterRender: function () {
		this.renderHeader();
		let $itemsContainer = this.$('.screening-category-items');
		_.each(this.model.items.models, function (item, index) {
			this.listenTo(item, 'change:status', _.bind(this.itemChanged, this));

			new PJQ.views.collapse.BaseCollapse({
				el: this.$el.closest('#screeningCategoryCollapse')
			});

			this.renderItemTabStatusBadge(item);

			let $item = $('<div>', {
				id: "screeningItemAccordionItem_" + item.cid,
				class: 'tab-pane fade screening-editor-item screening-editor-item-toggle' + (index === 0 ? ' show active' : ''),
				'data-cid': item.cid,
				role: 'tabpanel'
			});
			$itemsContainer.append($item);

			new PJQ.views.screenings.ScreeningItem({
				el: $item,
				model: item,
				categoryView: this,
				canManage: this.options.canManage === true,
				isAdmin: this.options.isAdmin === true
			});
		}, this);

		if (_.size(this.model.grades.models) > 0) {
			let grade = this.model.get('gradeId');
			let gradeSelector = new PJQ.inputs.Selectpicker({
				el: this.$('.select-grade'),
				isIntChoices: true,
				noneSelectedText: 'Needs Approval',
				defaultValue: grade,
				onChange: _.bind(function (newGrade) {
					gradeSelector.hideError();
					this.model.set('gradeId', newGrade > 0 ? newGrade : null);
					this.updateGrade();
				}, this)
			});

			if(!(grade > 0)){
				gradeSelector.showError();
			}
		}
	},
	updateGrade: function () {
		let contactId = this.options.client.get('contactId');
		if (!(contactId > 0)) {
			return;
		}
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'contacts',
					value: contactId
				},
				{
					endpoint: 'screenings',
				},
				{
					endpoint: 'categories',
					value: this.model.id
				}
			], [
				{
					parameter: 'grade',
					value: this.model.get('gradeId')
				},
				{
					parameter: 'flagged',
					value: this.model.get('isFlagged')
				}
			])
		}).put();
	},
	renderHeader: function () {
		this.renderSubTemplate(false, this.options.subTemplates.header, this.$('.category-header'), {
			model: this.model,
			canManage: this.options.canManage === true,
			isAdmin: this.options.isAdmin === true
		});
	},
	itemChanged: function (changedItem) {
		this.renderHeader();
		this.renderItemTabStatusBadge(changedItem);
	},
	renderItemTabStatusBadge: function (item) {
		let badgeContainer = this.$('a[href="#screeningItemAccordionItem_' + item.cid + '"]').find('.screening-status-badge-container'),
			badge = $('<span>', {
				class: 'badge fs-13',
				style: 'background-color:' + item.get('status').textColor + ';color:' + item.get('status').backgroundColor
			}).text(item.get('status').name);
		badgeContainer.html(badge);
	}
});

PJQ.views.screenings.ScreeningItem = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Screening-Editor-Item'),
		subTemplates: {
			header: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Screening-Editor-Item-Header'),
			comment: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Screening-Editor-Item-Comment'),
			question: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Screening-Editor-Item-Question'),
			questionInput: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Screening-Editor-Item-Question-Input'),
			footer: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Screening-Editor-Item-Footer'),
		}
	},
	events: {
		'change .screening-item-cant-provide': 'cantProvideChanged',
		'click .screening-item-in-process': 'updateItemInProcess',
		'click .screening-item-expired': 'updateItemExpired',
		'click .screening-item-incomplete': 'updateItemIncomplete',
		'click .screening-item-complete': 'updateItemComplete',
		'click .screening-item-done': 'submitItem',
		'keyup .screening-item-comment-input': 'commentChanged',
		'click .screening-item-comment-add': 'addComment'
	},
	beforeRender: function () {
		this.renderData = {
			model: this.model,
			canEdit: this.model.get('status').canEdit,
			subTemplates: this.options.subTemplates,
			canManage: this.options.canManage === true,
			isAdmin: this.options.isAdmin === true
		};
	},
	afterRender: function () {
		this.renderHeader();
		this.renderFooter();
		if (this.model.get('isFileUpload')) {
			this.renderFileUploader();
		}
		else if (_.size(this.model.questions.models) > 0) {
			this.renderQuestions();
		}
		this.renderComments();
	},
	renderQuestions: function () {
		let $questionContainer = this.$('.screening-item-questions');
		_.each(this.model.questions.models, function (question) {
			this.renderSubTemplate(true, this.options.subTemplates.question, $questionContainer, {
				model: question,
				canEdit: this.model.get('status').canEdit && this.model.get('status').screeningStatusId !== 7,
				subTemplates: this.options.subTemplates,
				canManage: this.options.canManage === true,
				isAdmin: this.options.isAdmin === true
			});
		}, this);

		let self = this;
		$questionContainer.find('.input-select,.input-bool').each(function () {
			let input = $(this);
			new PJQ.inputs.Selectpicker({
				el: input,
				onChange: function (value) {
					if (input.hasClass('input-bool'))
						value = value.toLowerCase() === 'true';

					let question = self.model.questions.get(input.data('cid'));
					self.questionValueChanged(question, value);
				}
			});

			new PJQ.Binder($questionContainer, null, {
				watchElements: [
					'input',
					'textarea'
				],
				onChange: function (changeEl, attribute, value) {
					let question = self.model.questions.get(changeEl.data('cid'));
					self.questionValueChanged(question, value);
				}
			});
		});
	},
	renderHeader: function () {
		let canManage = this.options.canManage === true,
			expires = this.model.get('expiresOn') == null ? null : new Date(this.model.get('expiresOn')),
			isExpired = PJQ.helpers.dateHelpers.checkDateIsBeforeToday(expires);
		this.renderSubTemplate(false, this.options.subTemplates.header, this.$('.screening-item-header'), {
			model: this.model,
			canManage: canManage,
			isAdmin: this.options.isAdmin === true
		}, _.bind(function () {
			if (canManage || expires != null) {
				new PJQ.inputs.DateEditorInput({
					el: this.$('.item-expiration'),
					canEdit: canManage,
					value: expires,
					dateFormat: PJQ.helpers.dateHelpers.dateFormats.DATE,
					label: expires != null && isExpired ? "Expired" : "Expires",
					onSave: _.bind(function (newValue) {
						this.model.updateExpiresOn(newValue, function () {
						});
					}, this)
				});
			}
		}, this));
	},
	renderFooter: function () {
		this.renderSubTemplate(false, this.options.subTemplates.footer, this.$('.screening-item-footer'), {
			model: this.model,
			canManage: this.options.canManage === true,
			isAdmin: this.options.isAdmin === true
		});
	},
	questionValueChanged: function (question, value) {
		question.set('responseValue', value);
		question.queueSave();
	},
	renderFileUploader: function () {
		this.fileUploader = new PJQ.views.files.FileUploaderGrid({
			el: this.$('.screening-item-file-upload'),
			collection: this.model.attachments,
			allowedExtensions: this.model.get('allowedExtensions'),
			isRemoveOnComplete: true,
			canUpload: this.model.get('status').canEdit && this.model.get('status').screeningStatusId !== 3,
			canDelete: this.options.isAdmin,
			showCreatedByLink: false,
			autoProcessQueue: this.model.get('status').needsAttention,
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'screenings',
					value: this.model.get('masterUserId')
				},
				{
					endpoint: 'items',
					value: this.model.id
				},
				{
					endpoint: 'attachments'
				}
			]),
			onDrop: _.bind(function () {
				if (!this.model.get('status').needsAttention) {
					new PJQ.views.BaseModal({
						header: 'Confirm Upload',
						body: '<div class="text-dark fs-14">Are you sure you want to upload new attachments?  You will have to re-submit this item.</div>',
						okButtonText: 'Yes',
						onOk: _.bind(function () {
							this.model.moveWaiting(_.bind(function () {
								this.options.categoryView.itemChanged(this.model);
								this.renderHeader();
								if (this.model.get('isRequired') === false) {
									this.$('.screening-item-cant-provide-container').removeClass('hidden');
								}
								this.fileUploader.dropzone.options.autoProcessQueue = true;
								this.fileUploader.dropzone.processQueue();
							}, this));
						}, this),
						isShowCancelButton: true,
						cancelButtonText: "No"
					});
				}
			}, this)
		});
	},
	cantProvideChanged: function () {
		let reasonModal = new PJQ.views.screenings.ProvideReasonModal({
			onConfirm: _.bind(function () {
				let reason = reasonModal.$('.provide-reason-input').val();
				this.model.submitProcessing(_.bind(function () {
					new PJQ.models.screenings.ScreeningComment({
						masterUserId: this.model.get('masterUserId'),
						screeningInviteItemId: this.model.id,
						comment: reason
					}).save(null, {
						success: _.bind(function (model) {
							this.model.comments.add(model);
							if (this.options.categoryView != null) {
								this.options.categoryView.itemChanged(this.model);
							}
							this.render();
						}, this)
					});
				}, this));
			}, this),
			onCancel: _.bind(function () {
				this.$('.screening-item-cant-provide').prop('checked', false);
			}, this),
		});
	},
	renderComments: function () {
		if (this.model.comments != null && _.size(this.model.comments.models) > 0) {
			let comments = _.sortBy(this.model.comments.models, function (comment) {
				return new Date(comment.get('createdOn'))
			}).reverse();
			new PJQ.Pagination(this.$('.screening-item-comments'), {
				dataSource: comments,
				renderData: {
					canManage: this.options.canManage === true,
					isAdmin: this.options.isAdmin
				},
				pageSize: 5,
				pageItemTemplate: this.options.subTemplates.comment
			});
		}
		else {
			this.$('.screening-item-comments').append($('<div>', {class: 'fs-16 text-muted text-align-center font-weight-light'}).text('No comments yet'));
		}
	},
	commentChanged: function () {
		let comment = this.$('.screening-item-comment-input').val();
		this.$('.screening-item-comment-add').prop('disabled', _.size(comment) === 0);
	},
	addComment: function () {
		let commentText = this.$('.screening-item-comment-input').val(),
			isVisibleContact = !this.options.isAdmin || this.$('.cb-comment-visible-contact').prop('checked');
		new PJQ.views.BaseModal({
			header: 'Confirm Comment',
			body: '<div class="text-dark fs-14">Are you sure you want to add this comment?  You will not be able to edit or remove it later.</div><div class="alert alert-primary mt-2 pre-wrap">' + commentText + '</div>',
			okButtonText: 'Yes',
			onOk: _.bind(function () {
				new PJQ.models.screenings.ScreeningComment({
					masterUserId: this.model.get('masterUserId'),
					screeningInviteItemId: this.model.id,
					comment: commentText,
					isVisibleContact: isVisibleContact
				}).save(null, {
					success: _.bind(function (model) {
						this.model.comments.add(model);
						this.renderComments();
						this.resetCommentInput();
					}, this)
				});
			}, this),
			isShowCancelButton: true,
			cancelButtonText: "No"
		})
	},
	resetCommentInput: function () {
		this.$('.screening-item-comment-input').val('');
		this.$('.screening-item-comment-add').prop('disabled', true);
	},
	validate: function () {
		let isValid = true;
		if (this.model.get('isFileUpload')) {
			if (this.model.get('isRequired') && _.size(this.model.attachments.models) === 0) {
				isValid = false;
				this.fileUploadValidationError = this.fileUploader.showError('You must upload at least 1 file', null);
			}
		}
		else {
			_.each(this.model.questions.models, function (question) {
				let isFieldValid = true;
				if (question.get('isRequired')) {
					if (question.get('type').toLowerCase() === 'bool') {
						if (question.get('responseValue') !== false && question.get('responseValue') !== true) {
							isFieldValid = false;
						}
					}
					else if (_.size(question.get('responseValue')) === 0) {
						isFieldValid = false;
					}
				}

				PJQ.helpers.inputHelpers.setInputError(this.$('[data-cid="' + question.cid + '"]'), isFieldValid);

				isValid = isValid ? isFieldValid : isValid;
			}, this);
		}
		return isValid;
	},
	updateItemInProcess: function () {
		if (this.options.isAdmin) {
			this.model.setStatus(PJQ.constants.screenings.statuses.IN_PROCESS, _.bind(function () {
				if (this.options.categoryView != null) {
					this.options.categoryView.itemChanged(this.model);
				}
				this.render();
			}, this));
		}
	},
	updateItemExpired: function () {
		if (this.options.canManage && this.options.isAdmin) {
			this.model.setStatus(PJQ.constants.screenings.statuses.EXPIRED, _.bind(function () {
				if (this.options.categoryView != null) {
					this.options.categoryView.itemChanged(this.model);
				}
				this.render();
			}, this));
		}
	},
	updateItemIncomplete: function () {
		if (this.options.canManage && this.options.isAdmin) {
			this.model.setStatus(PJQ.constants.screenings.statuses.INCOMPLETE, _.bind(function () {
				if (this.options.categoryView != null) {
					this.options.categoryView.itemChanged(this.model);
				}
				this.render();
			}, this));
		}
	},
	updateItemComplete: function () {
		if (this.options.canManage && this.options.isAdmin) {
			this.model.setStatus(PJQ.constants.screenings.statuses.COMPLETE, _.bind(function () {
				if (this.options.categoryView != null) {
					this.options.categoryView.itemChanged(this.model);
				}
				this.render();
			}, this));
		}
	},
	submitItem: function () {
		if (this.validate()) {
			this.model.submitProcessing(_.bind(function () {
				if (this.options.categoryView != null) {
					this.options.categoryView.itemChanged(this.model);
				}
				this.render();
			}, this));
		}
	}
});

PJQ.views.screenings.ProvideReasonModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Modal-Screening-Editor-Provide-Reason'),
		onCancel: _.noop,
		onConfirm: _.noop
	},
	events: {
		'keyup .provide-reason-input': 'reasonChanged',
		'click .provide-reason-cancel': 'cancel',
		'click .provide-reason-confirm': 'confirm'
	},
	reasonChanged: function () {
		let reason = this.$('.provide-reason-input').val();
		this.$('.provide-reason-confirm').prop('disabled', _.size(reason) === 0);
	},
	cancel: function () {
		this.options.onCancel();
	},
	confirm: function () {
		this.options.onConfirm();
	}
});

PJQ.views.screenings.ScreeningTermsModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Modal-Screening-Terms'),
		onComplete: _.noop,
		maxWidth: '800px'
	},
	events: {
		'click .terms-accept': 'accept'
	},
	afterRender: function () {
		this.$('.terms-text').height($(window).height() - 250);
		this.renderNextTerm();
	},
	renderNextTerm: function () {
		this.currentTerm = this.getNextTerm();
		if (this.currentTerm == null) {
			this.removeModal();
			if (typeof this.options.onComplete === 'function')
				this.options.onComplete();
		}
		else {
			this.$('.terms-title').html(this.currentTerm.get('title'));
			this.$('.terms-text').html(this.currentTerm.get('text'));
		}
	},
	getNextTerm: function () {
		return _.find(this.collection.models, function (term) {
			return term.get('isActive') && !term.get('isAccepted');
		});
	},
	accept: function () {
		this.currentTerm.save({
			isAccepted: true
		}, {
			success: _.bind(function () {
				this.renderNextTerm();
			}, this)
		});
	}
});

PJQ.views.screenings.ScreeningInvitePackagesModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Modal-Screening-Invite-Packages'),
		onComplete: _.noop,
		maxWidth: 800
	},
	afterRender: function () {
		this.dataTable = new PJQ.views.dataTables.DataTable({
			el: '.packages-table',
			data: this.options.packages,
			isHideSearch: true,
			rowId: 'cid',
			order: [1, 'asc'],
			language: {
				zeroRecords: 'No packages have been requested yet'
			},
			columns: [
				{
					"data": "name",
					"title": "Name",
					"width:": "40%"
				},
				{
					"data": "requestedOn",
					"title": "Requested",
					"render": function (data, type, row) {
						return data ? PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE) : '';
					}
				},
				{
					"data": "enrolledOn",
					"title": "Enrolled",
					"render": function (data, type, row) {
						return data ? PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE) : '';
					}
				},
				{
					"data": "expiresOn",
					"title": "Expires",
					"render": function (data, type, row) {
						return data ? PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE) : '';
					}
				}
			]
		});
	}
});
